<template>
  <div class="content-body">
    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getQRSerial"
      :manual="true"
      :photo="cameraMode"
      @onPhoto="getCamRes"
      @onBarcode="onDecodeBar"
      :barCode="barcode"
    />

    <modalEq
      ref="modalEq"
      :title="$t('tasks.eqMethod.equipm')"
      :preSelected="newTask.serials"
      @onClose="getChoosenEq"
    ></modalEq>

    <modalExecutor :data="executors" :final_func="closeExec"></modalExecutor>

    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />
    <ModalEqInfo ref="eqInfo" />
    <ModalAppealInfo ref="appealInfo" />

    <vue-modal :on-close="closeModalMap" name="map-modal">
      <h5 slot="header" style="text-align: center">{{ modalMap.title }}</h5>
      <div class="row row-map">
        <GmapMap
          :center="modalMap.position"
          :zoom="17"
          map-type-id="terrain"
          style="height: 600px"
        >
          <GmapMarker
            :position="modalMap.position"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 mb-3"></div>
      </div>
    </vue-modal>

    <div ref="taskInfoCont" id="taskInfoCont"></div>
    <div class="row match-height" v-show="showinfo">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="form-section">
              <i class="icon-info"></i>
              {{ $t("tasks.titles.details") + " " + dataTask.docNumber }}
              <span
                v-if="dataTask.priority != null"
                class="tag"
                :class="
                  'tag-' +
                  $t('priority.statuses.' + dataTask.priority + '.class')
                "
              >
                {{ $t("priority.statuses." + dataTask.priority + ".word") }}
              </span>
            </h3>

            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="showinfo = false"
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block">
              <div class="d-flex flex-row mb-1" v-if="dataTask.problemGuid">
                <div class="d-flex">
                  <button
                    style="float: left !important"
                    type="button"
                    class="btn btn-primary"
                    @click="showModalAppealinfo(dataTask.problemGuid)"
                  >
                    {{ $t("titles.problem") + " " + dataTask.problemName }}
                  </button>
                  <button
                    v-if="dataTask.msp_id"
                    type="button"
                    class="btn btn-success ml-2"
                    @click="clickMSPTask"
                  >
                    {{ $t("tasks.titles.openExtTask") }}
                  </button>
                </div>
              </div>

              <ul
                class="nav nav-tabs mb-1"
                v-if="!dataTask.modalDistServ.modalshow"
              >
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.hint.detail')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataTask.tabs.info }"
                    id="base-tab1"
                    data-toggle="tab"
                    @click="dataTask.tabs.info = true"
                  >
                    <i class="icon-info"></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.table.images')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataTask.tabs.photo }"
                    id="base-tab2"
                    data-toggle="tab"
                    @click="dataTask.tabs.photo = true"
                  >
                    <i class="icon-images2"></i>
                  </a>
                </li>
                <!-- <li class="nav-item">
                                    <a class="nav-link" v-bind:class="{'active': dataTask.tabs.files }" id="base-tab3" data-toggle="tab" @click="dataTask.tabs.files = true">
                                        <i class="icon-file-text2"></i>
                                    </a>
                                </li> -->
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.titles.history')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataTask.tabs.history }"
                    id="base-tab4"
                    data-toggle="tab"
                    @click="dataTask.tabs.history = true"
                  >
                    <i class="icon-history"></i>
                  </a>
                </li>
              </ul>
              <div
                class="col-md-10 offset-md-1"
                v-if="dataTask.tabs.info && !dataTask.modalDistServ.modalshow"
              >
                <div class="row">
                  <div class="col-md-12" v-if="dataTask.btns.pdf">
                    <button
                      type="button"
                      style="float: right !important"
                      class="btn btn-warning"
                      @click="sendReport()"
                    >
                      <i class="icon-printer3"></i>
                      {{ $t("tasks.buttons.downloadDoc") }}
                    </button>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="
                      ($store.state.listRole.admin ||
                        $store.getters.getDispatcher) &&
                      (dataTask.statusBP == 1 || dataTask.statusBP == 2)
                    "
                  >
                    <button
                      style="float: left !important"
                      type="button"
                      class="btn btn-primary"
                      @click="showModalExec()"
                    >
                      {{ $t("tasks.buttons.exec") }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="typeTask">{{ $t("tasks.table.type") }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="typeTask"
                          class="form-control border-primary"
                          name="typeTask"
                          :value="$t(dataTask.WorkType)"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-clipboard2"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="typeTask">{{
                        $t("equipm.table.location")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="address"
                          name="address"
                          class="form-control border-primary"
                          v-model="dataTask.address"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-location-arrow"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="row mb-1">
                                    <div class="col-md-12">
                                        <form class="form">
                                            <h4 class="form-section"><i class="icon-location-arrow"></i> {{$t('equipm.table.location')}}</h4>
                                            <div class="mobileTbl table-responsive">
                                                <table class="table table-hover mb-0" cellspacing="0">
                                                    <thead>
                                                        <tr>
                                                            <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                                            <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                                            <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                                            <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                                            <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                                            <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td :data-title="$t('equipm.table.country')">{{dataTask.addressT.country}}</td>
                                                            <td :data-title="$t('equipm.table.region')">{{dataTask.addressT.region}}</td>
                                                            <td :data-title="$t('equipm.table.city')">{{dataTask.addressT.city}}</td>
                                                            <td :data-title="$t('equipm.table.street')">{{dataTask.addressT.street}}</td>
                                                            <td :data-title="$t('equipm.table.street')">{{dataTask.addressT.streetN}}</td>
                                                            <td :data-title="$t('equipm.table.index')">{{dataTask.addressT.index}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </form>
                                    </div>
                                </div> -->

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="organiz">{{
                        $t("registr.lbl.organization")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="organiz"
                          name="organiz"
                          class="form-control border-primary"
                          v-model="dataTask.organization"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-office"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="execPers">{{
                        $t("tasks.table.execPers")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="execPers"
                          name="execPers"
                          class="form-control border-primary"
                          :value="dataTask.execPers"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-user"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="contPers">{{
                        $t("tasks.table.contPers")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="contPers"
                          name="contPers"
                          class="form-control border-primary"
                          :value="dataTask.contPers"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-user"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="jobss">{{ $t("tasks.table.jobs") }}</label>
                  <div class="position-relative has-icon-left">
                    <div class="form-control-position">
                      <i class="icon-clipboard2"></i>
                    </div>
                    <!-- <textarea id="jobss" name="jobss" rows="2" class="form-control border-primary" v-model="dataTask.jobs" disabled></textarea> -->
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef; min-height: 2em"
                    >
                      {{ dataTask.jobs }}
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-group mb-0">
                    <label for="comment">{{ $t("tasks.table.comment") }}</label>
                    <button
                      type="button"
                      class="btn tag-warning"
                      v-if="!dataTask.addComm && dataTask.statusBP != 5"
                      @click="dataTask.addComm = true"
                      data-html="true"
                      :title="$t('tasks.table.comment')"
                    >
                      <i style="color: #ffffff" class="icon-plus2"></i>
                    </button>
                  </div>

                  <div class="form-group" v-if="dataTask.addComm">
                    <div class="position-relative has-icon-left">
                      <div class="form-control-position">
                        <i class="icon-file-text"></i>
                      </div>
                      <textarea
                        id="commentAdd"
                        name="commentAdd"
                        rows="2"
                        class="form-control border-primary"
                        v-model="dataTask.newComment"
                      ></textarea>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-end;
                        margin-top: 5px;
                      "
                    >
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="saveCommentTask()"
                          data-html="true"
                          :title="$t('profile.buttons.save')"
                        >
                          <i class="icon-check2"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="
                            dataTask.addComm = false;
                            dataTask.newComment = '';
                          "
                          data-html="true"
                          :title="$t('equipm.buttons.cancel')"
                        >
                          <i class="icon-cross2"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" style="margin-top: 5px">
                    <div class="position-relative has-icon-left">
                      <div class="form-control-position">
                        <i class="icon-file-text"></i>
                      </div>
                      <textarea
                        id="comment"
                        name="comment"
                        rows="4"
                        class="form-control border-primary"
                        v-model="dataTask.comment"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div>

                <!-- список проблемних категорій -->
                <div class="row mb-1" v-if="dataTask.problemsList.length > 0">
                  <div class="col-md-12">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-loop22"></i>
                        {{ $t("titles.componProbl") }}
                      </h4>
                    </form>

                    <div
                      class="col-md-6 mb-1"
                      v-if="$store.state.listRole.service"
                    >
                      <div class="input-group col-form-label-lg pb-0">
                        <div
                          class="form-control border-primary"
                          style="background-color: #eceeef"
                          id="typeFltr"
                          @click="listProbShow2 = !listProbShow2"
                        >
                          {{ $t("problem.titles.chProbl2") }}
                        </div>

                        <div class="input-group-append">
                          <button
                            type="button"
                            class="btn btn-primary btn-round"
                            @click="listProbShow2 = !listProbShow2"
                          >
                            <a
                              class="icon-filter dropdown-toggle"
                              style="color: white"
                            ></a>
                          </button>
                        </div>
                      </div>
                      <div class="dropdown-menu" v-if="listProbShow2">
                        <button
                          v-for="(item, index) in dataTask.categories"
                          :key="index"
                          class="hand dropdown-item"
                          type="button"
                          @click="
                            dataTask.problemsList.push({
                              id: item.id,
                              guid: item.guid,
                              title: item.title,
                              class: item.class,
                              comment: null,
                              edit: false,
                              editbl: true,
                            });
                            listProbShow2 = !listProbShow2;
                          "
                        >
                          <i :class="item.class"></i>
                          <span>{{ $t(item.title) }}</span>
                        </button>
                      </div>
                    </div>

                    <div class="mobileTbl table-responsive">
                      <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                          <tr>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            ></th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            >
                              {{ $t("equipm.table.nameEq") }}
                            </th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            >
                              {{ $t("tasks.table.comment") }}
                            </th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in dataTask.problemsList"
                            :key="index"
                          >
                            <!--paginatedData listTasks-->
                            <td class="text-truncate" data-title="">
                              <i class="font-large-1" :class="item.class"></i>
                            </td>
                            <td
                              class="text-truncate"
                              :data-title="$t('equipm.table.nameEq')"
                            >
                              <span>{{ item.title }}</span>
                            </td>
                            <td
                              class="text-truncate"
                              :data-title="$t('tasks.table.comment')"
                            >
                              <div class="position-relative">
                                <!-- <input type="text" id="prComment" name="prComment" class="form-control border-primary" :value="item.comment"> -->
                                <textarea
                                  v-if="item.edit"
                                  id="prComment"
                                  name="prComment"
                                  rows="2"
                                  class="form-control border-primary"
                                  v-model="item.comment"
                                ></textarea>
                                <div
                                  v-if="!item.edit"
                                  class="form-control border-primary"
                                  style="
                                    background-color: #eceeef;
                                    min-height: 2em;
                                  "
                                  id="typeFltr"
                                >
                                  {{ item.comment }}
                                </div>
                              </div>
                            </td>
                            <td class="text-truncate">
                              <div
                                class="row"
                                style="float: right; margin-right: 5px"
                              >
                                <div class="btn-group">
                                  <button
                                    type="button"
                                    v-if="$store.state.listRole.service"
                                    :class="[
                                      item.edit ? 'btn-danger' : 'btn-warning',
                                    ]"
                                    class="btn"
                                    @click="item.edit = !item.edit"
                                  >
                                    <i
                                      :class="[
                                        item.edit
                                          ? 'icon-cross'
                                          : 'icon-pencil22',
                                      ]"
                                    ></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-success"
                                    v-if="item.edit"
                                    @click="commProblEq(item)"
                                  >
                                    <i class="icon-floppy-disk"></i>
                                  </button>
                                  <button
                                    type="button"
                                    v-if="
                                      !item.edit && dataTask.btns.replacement
                                    "
                                    class="btn btn-primary"
                                    @click="
                                      dataTask.tabs.change = true;
                                      probChoosen = {
                                        title: item.title,
                                        guid: item.guid,
                                        class: item.class,
                                        id: item.id,
                                      };
                                      addChange();
                                    "
                                  >
                                    <i class="icon-loop22"></i>
                                  </button>
                                  <!-- editbl -->
                                  <button
                                    type="button"
                                    class="btn btn-danger"
                                    v-if="!item.edit && item.editbl"
                                    @click="
                                      dataTask.problemsList.splice(index, 1)
                                    "
                                    data-html="true"
                                    :title="$t('problem.btns.delete')"
                                  >
                                    <i class="icon-bin"></i>
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- список проблемних категорій -->

                <ul class="nav nav-tabs mb-1">
                  <li
                    class="nav-item"
                    data-html="true"
                    :title="$t('titles.equipment')"
                  >
                    <a
                      class="nav-link"
                      v-bind:class="{ active: dataTask.tabs.equipm }"
                      id="base-tab5"
                      data-toggle="tab"
                      @click="dataTask.tabs.equipm = true"
                    >
                      <i class="icon-menu"></i>
                    </a>
                  </li>
                  <li
                    class="nav-item"
                    data-html="true"
                    :title="$t('titles.changesComp')"
                  >
                    <a
                      class="nav-link"
                      v-bind:class="{ active: dataTask.tabs.change }"
                      id="base-tab6"
                      data-toggle="tab"
                      @click="dataTask.tabs.change = true"
                    >
                      <i class="icon-loop22"></i>
                    </a>
                  </li>
                </ul>

                <div class="row" v-if="dataTask.tabs.equipm">
                  <div class="col-md-12">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-eye6"></i> {{ $t("titles.equipment") }}
                      </h4>
                    </form>

                    <div
                      class="mobileTbl table-responsive"
                      v-if="dataTask.equipment.length > 0"
                    >
                      <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                          <tr>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.nameEq") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.serNumber") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.location") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.actDt") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.guarantee") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(eq, index) in dataTask.equipment"
                          :key="index"
                        >
                          <tr @click="showModalEqinfo(eq.serial)" class="hand">
                            <td :data-title="$t('equipm.table.nameEq')">
                              <span>{{ eq.name }}</span>
                            </td>
                            <td
                              :data-title="$t('equipm.table.serNumber')"
                              class="text-truncate"
                            >
                              <span>{{ eq.serial }}</span>
                            </td>
                            <td
                              :data-title="$t('equipm.table.location')"
                              class=""
                            >
                              <a
                                v-if="eq.city.length > 5"
                                class=""
                                @click.self="
                                  showModalMap(
                                    $event,
                                    eq.city,
                                    eq.name + ' (' + eq.serial + ')'
                                  )
                                "
                              >
                                {{ eq.city }}
                                <i class="icon icon-location2"></i>
                              </a>
                              <span v-else>{{ eq.city }}</span>
                            </td>
                            <td
                              :data-title="$t('equipm.table.actDt')"
                              class="text-truncate"
                            >
                              <span>{{ eq.actDt }}</span>
                            </td>
                            <td
                              :data-title="$t('equipm.table.guarantee')"
                              class="text-truncate"
                            >
                              <div v-if="eq.guarantee" class="tag tag-success">
                                {{ $t("equipm.table.guarantee") }}
                              </div>
                              <div v-if="!eq.guarantee" class="tag tag-danger">
                                {{ $t("equipm.table.noGuar") }}
                              </div>
                            </td>
                          </tr>
                          <tr v-if="eq.history.length > 0" class="marginTR">
                            <td></td>
                            <td :colspan="5" class="paddingTD">
                              <span style="font-size: 0.8em">{{
                                eq.history
                              }}</span>
                            </td>
                            <!-- <table class="childTable table table-hover mb-0">
                                                            <thead><tr><th scope="col">Task</th><th scope="col">Status</th></tr></thead>
                                                            <tbody v-for="(action,ind) in eq.history" :key="ind"><tr>
                                                                <td data-title="Task" scope="row">{{action.task}}</td>
                                                                <td data-title="Status">{{action.status}}</td>
                                                            </tr></tbody>
                                                        </table> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="dataTask.tabs.change">
                  <div class="col-md-12">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-loop22"></i>
                        {{ $t("titles.changesComp") }}
                      </h4>
                    </form>

                    <div class="row" v-if="dataTask.btns.replacement">
                      <div class="col-md-6">
                        <div class="input-group col-form-label-lg pb-0">
                          <div
                            class="form-control border-primary"
                            style="background-color: #eceeef"
                            id="typeFltr"
                            @click="listProbShow = !listProbShow"
                          >
                            {{ choosProbl }}
                          </div>

                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-primary btn-round"
                              @click="listProbShow = !listProbShow"
                              data-html="true"
                              :title="$t('problem.titles.chProbl2')"
                            >
                              <a
                                class="icon-filter dropdown-toggle"
                                style="color: white"
                              ></a>
                            </button>
                          </div>
                        </div>
                        <div class="dropdown-menu" v-if="listProbShow">
                          <button
                            v-for="(item, index) in dataTask.categories"
                            :key="index"
                            class="hand dropdown-item"
                            type="button"
                            @click="
                              probChoosen = item;
                              listProbShow = !listProbShow;
                              addChange();
                            "
                          >
                            <i :class="item.class"></i>
                            <span>{{ $t(item.title) }}</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <table
                          class="table table-hover mb-0 mt-1"
                          cellspacing="0"
                        >
                          <tbody>
                            <tr
                              v-for="(item, indexC) in dataTask.changes"
                              :key="indexC"
                            >
                              <td>
                                <div class="d-flex">
                                  <span style="justify-content: flex-start"
                                    ><i :class="item.class"></i>
                                    {{ $t(item.title) }}</span
                                  >
                                </div>

                                <div
                                  class="d-flex mt-1"
                                  style="justify-content: flex-start"
                                >
                                  <div class="input-group">
                                    <input
                                      class="form-control border-primary"
                                      :placeholder="
                                        $t('tasks.errors.entrSerial')
                                      "
                                      type="text"
                                      v-model="item.serial"
                                    />
                                    <div class="input-group-append">
                                      <button
                                        type="button"
                                        class="btn btn-warning btn-round"
                                        @click="
                                          dataTask.chChange = item;
                                          barcode = false;
                                          showModalQR();
                                        "
                                        data-html="true"
                                        :title="$t('equipm.hint.scanQr')"
                                      >
                                        <i
                                          style="color: #ffffff"
                                          class="icon-qrcode"
                                        ></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="d-flex mt-1"
                                  style="justify-content: center"
                                >
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <div
                                        class="btn btn-primary btn-round"
                                        style="min-width: 6em"
                                      >
                                        <span>{{
                                          $t("tasks.titles.chng")
                                        }}</span>
                                      </div>
                                    </div>
                                    <input
                                      class="form-control border-primary"
                                      :placeholder="
                                        $t('tasks.errors.entrSerial')
                                      "
                                      type="text"
                                      v-model="item.serialFrom"
                                    />
                                    <div class="input-group-append">
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-round"
                                        @click="
                                          tempBar = {
                                            index: indexC,
                                            name: 'serialFrom',
                                          };
                                          barcode = true;
                                          showModalQR();
                                        "
                                        data-html="true"
                                        :title="$t('equipm.hint.barcode')"
                                      >
                                        <i class="icon-barcode"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="d-flex mt-1"
                                  style="justify-content: center"
                                >
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <div
                                        class="btn btn-primary btn-round"
                                        style="min-width: 6em"
                                      >
                                        <span
                                          >{{ $t("tasks.titles.on") }}
                                        </span>
                                      </div>
                                    </div>
                                    <input
                                      class="form-control border-primary"
                                      :placeholder="
                                        $t('tasks.errors.entrSerial')
                                      "
                                      type="text"
                                      v-model="item.serialTo"
                                    />
                                    <div class="input-group-append">
                                      <button
                                        type="button"
                                        class="btn btn-secondary btn-round"
                                        @click="
                                          tempBar = {
                                            index: indexC,
                                            name: 'serialTo',
                                          };
                                          barcode = true;
                                          showModalQR();
                                        "
                                        data-html="true"
                                        :title="$t('equipm.hint.barcode')"
                                      >
                                        <i class="icon-barcode"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="d-flex mt-1"
                                  style="justify-content: flex-end"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-danger"
                                    v-on:click="
                                      dataTask.changes.splice(indexC, 1)
                                    "
                                    data-html="true"
                                    :title="$t('problem.btns.delete')"
                                  >
                                    <i class="icon-bin"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="dataTask.changes.length > 0">
                              <td>
                                <div
                                  class="d-flex mt-1"
                                  style="justify-content: flex-end"
                                >
                                  <button
                                    class="btn btn-success"
                                    type="button"
                                    @click="saveChange()"
                                  >
                                    <i class="icon-checkmark2"></i>
                                    <span>{{ $t("problem.btns.create") }}</span>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="col-md-12">
                        <div class="mobileTbl table-responsive">
                          <table class="table table-hover mb-0" cellspacing="0">
                            <thead>
                              <tr>
                                <th
                                  class="text-truncate"
                                  style="vertical-align: middle"
                                ></th>
                                <th
                                  class="text-truncate"
                                  style="vertical-align: middle"
                                >
                                  {{ $t("equipm.table.nameEq") }}
                                </th>
                                <th
                                  class="text-truncate"
                                  style="vertical-align: middle"
                                >
                                  {{ $t("problem.table.chFrom") }}
                                </th>
                                <th
                                  class="text-truncate"
                                  style="vertical-align: middle"
                                >
                                  {{ $t("problem.table.chTo") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(ch, index) in dataTask.changesList"
                                :key="index"
                              >
                                <td>
                                  <i :class="ch.class"></i>
                                  <span>{{ $t(ch.title) }}</span>
                                </td>
                                <td :data-title="$t('equipm.table.nameEq')">
                                  <span>{{ ch.nameEq }}</span>
                                </td>
                                <td :data-title="$t('problem.table.chFrom')">
                                  <span>{{ ch.from }}</span>
                                </td>
                                <td :data-title="$t('problem.table.chTo')">
                                  <span>{{ ch.to }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- foto -->
              <div
                class="col-md-12"
                v-if="dataTask.tabs.photo && !dataTask.modalDistServ.modalshow"
              >
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                  </h4>
                </form>

                <div class="row">
                  <div
                    class="col-md-12"
                    style="display: flex; flex-wrap: wrap"
                    v-if="dataTask.taskPict.length > 0"
                  >
                    <div
                      class="col-xs-2"
                      style="
                        padding: 0;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        margin-bottom: 1em;
                      "
                      v-for="(image, index) in dataTask.taskPict"
                      :key="index"
                    >
                      <div class="card hand mb-0" style="margin-left: 5px">
                        <div class="w-100 h-100">
                          <img
                            :src="image"
                            style="max-width: 100%; max-height: 100%"
                            @click="expandDiv(dataTask.taskPict, index)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row" v-if="dataTask.taskPict.length < dataTask.countPhoto">
                                    <div class="col-md-12">
                                        <form class="form-body">
                                            <div class="form-actions center mt-0 mb-0" style="padding: 0;">
                                                <button type="button" class="btn btn-secondary" @click="loadPictures()"><i class="icon-download"></i> {{dataTask.taskPict.length + ' / ' + dataTask.countPhoto}}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div> -->
              </div>
              <!-- history -->
              <div
                class="col-md-12"
                v-if="
                  dataTask.tabs.history && !dataTask.modalDistServ.modalshow
                "
              >
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-history"></i>
                    {{ $t("tasks.titles.history") }}
                  </h4>
                </form>
                <div
                  class="mobileTbl table-responsive"
                  v-if="dataTask.history.length > 0"
                >
                  <table class="table table-hover mb-0" cellspacing="0">
                    <thead>
                      <tr>
                        <!-- <th style="vertical-align: middle;">{{ $t('tasks.table.docNumb') }}</th> -->
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.status") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.date") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.rspnsbl") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.elapsedTime") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.comment") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(el, index) in dataTask.history" :key="index">
                        <!-- guid -->
                        <!-- <td :data-title="$t('tasks.table.docNumb')">
                                                    <span>{{el.docNumber}}</span>
                                                </td> -->
                        <td :data-title="$t('tasks.table.status')">
                          <span
                            class="tag"
                            :class="'tag-' + $t(el.stage + '.class')"
                            >{{ $t(el.stage + ".title") }}</span
                          >
                        </td>
                        <td :data-title="$t('tasks.table.date')">
                          <span>{{ el.date }}</span>
                        </td>
                        <td :data-title="$t('tasks.table.rspnsbl')">
                          <span>{{ el.responsible }}</span>
                        </td>
                        <td :data-title="$t('tasks.table.elapsedTime')">
                          <span v-if="el.spentTime != 0"
                            >{{ el.spentTime }} {{ $t("meas.min") }}</span
                          >
                        </td>
                        <td :data-title="$t('tasks.table.comment')">
                          <span>{{ el.comment }}</span>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataTask.sumHistory != null &&
                          dataTask.sumHistory != 0
                        "
                      >
                        <td colspan="2"></td>
                        <td>
                          <span
                            >{{ dataTask.sumHistory }}
                            {{ $t("meas.min") }}</span
                          >
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- history -->

              <div
                class="col-md-10 offset-md-1"
                style="margin-top: 2rem"
                v-if="dataTask.tabs.info && !dataTask.modalDistServ.modalshow"
              >
                <form class="form">
                  <h4 class="form-section">{{ $t("titles.eq1") }}</h4>
                </form>

                <form class="form">
                  <div
                    class="row"
                    v-show="
                      dataTask.moving.finish && $store.state.listRole.service
                    "
                  >
                    <div
                      class="col-md-12"
                      style="margin-top: 5px; margin-bottom: 5px"
                    >
                      <div class="form-group mb-0">
                        <button
                          type="button"
                          id="taskQRbtn"
                          ref="taskQRbtn"
                          class="btn btn-warning btn-round"
                          @click="
                            barcode = false;
                            showModalQR();
                          "
                          data-html="true"
                          :title="$t('equipm.hint.scanQr')"
                        >
                          <i class="icon-qrcode"></i>
                          {{
                            $t("tasks.buttons.addSerial") +
                            " " +
                            $t("equipm.table.serNumber")
                          }}
                        </button>
                      </div>
                    </div>

                    <div
                      class="col-md-12"
                      v-if="finishTaskData.equipment.length > 0"
                    >
                      <div
                        class="mobileTbl table-responsive"
                        v-if="dataTask.equipment.length > 0"
                      >
                        <table class="table table-hover mb-0" cellspacing="0">
                          <thead>
                            <tr>
                              <th style="vertical-align: middle">
                                {{ $t("equipm.table.serNumber") }}
                              </th>
                              <th style="vertical-align: middle">
                                {{ $t("tasks.table.comment") }}
                              </th>
                              <th style="vertical-align: middle"></th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(eq, index) in finishTaskData.equipment"
                            :key="index"
                          >
                            <tr>
                              <td :data-title="$t('equipm.table.serNumber')">
                                <a>{{ eq.serial }}</a>
                              </td>
                              <td :data-title="$t('tasks.table.comment')">
                                <textarea
                                  rows="3"
                                  class="form-control border-primary"
                                  v-model="eq.comment"
                                ></textarea>
                              </td>
                              <td style="vertical-align: middle">
                                <div>
                                  <button
                                    type="button"
                                    class="btn btn-warning"
                                    style="float: right"
                                    v-on:click="
                                      finishTaskData.equipment.splice(index, 1)
                                    "
                                    data-html="true"
                                    :title="$t('equipm.hint.delete')"
                                  >
                                    <i class="icon-bin"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="distance">{{
                              $t("tasks.table.distance")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="distance"
                                name="distance"
                                class="form-control border-primary"
                                v-model="finishTaskData.distanceKM"
                                @keypress="isNumber($event)"
                              />
                              <div class="form-control-position">
                                <i class="icon-road"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 5px">
                      <input
                        type="file"
                        name="file2"
                        id="file2"
                        class="inputfile"
                        multiple="multiple"
                        accept="image/x-png,image/jpeg,audio/mpeg3, video/*"
                        @change="onUploadImg"
                        :value="inputFileValue"
                      />
                      <label id="file_loader2" for="file2">
                        <a class="btn btn-primary btn-min-width"
                          ><i class="icon-upload3"></i>
                          {{ $t("tasks.buttons.file") }}</a
                        >
                      </label>
                      <button
                        type="button"
                        class="btn btn-warning"
                        @click="
                          cameraMode = true;
                          barcode = false;
                          showModalQR();
                        "
                        data-html="true"
                        :title="$t('equipm.hint.camera')"
                      >
                        <i style="color: #ffffff" class="icon-camera8"></i>
                        {{ $t("tasks.buttons.photo") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="
                          finishTaskData.images = [];
                          finishTaskData.images2 = [];
                        "
                        v-if="finishTaskData.images.length > 0"
                      >
                        <i class="icon-bin"></i>
                        {{ $t("tasks.buttons.remove") }}
                      </button>
                    </div>

                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                      v-if="finishTaskData.images.length > 0"
                    >
                      <div
                        class="col-xs-4"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in finishTaskData.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              @click="
                                finishTaskData.images.splice(index, 1);
                                finishTaskData.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              v-bind:src="image.data"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(finishTaskData.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-show="dataTask.moving.comment">
                    <div class="col-md-12" style="margin-top: 5px">
                      <div class="form-body">
                        <div class="form-group mb-0">
                          <div class="position-relative has-icon-left">
                            <textarea
                              id="reasonComment"
                              name="reasonComment"
                              rows="3"
                              class="form-control border-primary"
                              v-model="dataTask.reasonComment"
                              v-bind:placeholder="titleComment"
                            ></textarea>
                            <div class="form-control-position">
                              <i class="icon-file-text"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-actions right mb-0"
                    style="margin-top: 5px; padding: 5px 0"
                  >
                    <div class="form-group" v-if="dataTask.moving.cancel">
                      <div class="" style="margin-top: 5px">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="changeroutetask(1)"
                        >
                          <i class="icon-check2"></i>
                          {{ $t("tasks.buttons.cancelTask") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="dataTask.moving.cancel = false"
                        >
                          <i class="icon-cross2"></i>
                          {{ $t("tasks.buttons.cnlChngTask") }}
                        </button>
                      </div>
                    </div>

                    <button
                      v-if="
                        !dataTask.moving.cancel &&
                        !dataTask.moving.finish &&
                        dataTask.btns.bring
                      "
                      type="button"
                      class="btn btn-warning"
                      style="margin-top: 5px"
                      @click="bringTask()"
                    >
                      <i class="icon-check2"></i>
                      {{ $t("tasks.buttons.bring") }}
                    </button>
                    <button
                      v-if="
                        !dataTask.moving.cancel &&
                        !dataTask.moving.finish &&
                        dataTask.btns.preCancel
                      "
                      type="button"
                      class="btn btn-danger"
                      style="margin-top: 5px"
                      @click="changeroutetask(1)"
                    >
                      <i class="icon-cross2"></i>
                      {{ $t("tasks.buttons.cancelTask") }}
                    </button>
                    <button
                      v-if="
                        !dataTask.moving.cancel &&
                        !dataTask.moving.finish &&
                        dataTask.btns.preFinish
                      "
                      type="button"
                      class="btn btn-success"
                      style="margin-top: 5px"
                      @click="finishTask()"
                    >
                      <i
                        class="icon-qrcode"
                        v-if="$store.state.listRole.service"
                      ></i>
                      <i
                        class="icon-check2"
                        v-if="!$store.state.listRole.service"
                      ></i>
                      {{ $t("tasks.buttons.finish") }}
                    </button>
                    <button
                      v-if="
                        (dataTask.moving.cancel || dataTask.moving.finish) &&
                        dataTask.btns.cancelChange
                      "
                      type="button"
                      class="btn btn-warning"
                      style="margin-top: 5px"
                      @click="cancelChanges()"
                    >
                      <i class="icon-cross2"></i>
                      {{ $t("tasks.buttons.cnlChngTask") }}
                    </button>
                    <button
                      v-if="
                        !dataTask.moving.cancel &&
                        dataTask.moving.finish &&
                        dataTask.btns.finish
                      "
                      value="3"
                      type="button"
                      class="btn btn-success"
                      style="margin-top: 5px"
                      @click="finishTask()"
                    >
                      <i class="icon-check2"></i>
                      {{ $t("tasks.buttons.finish") }}
                    </button>
                  </div>
                </form>
              </div>

              <div class="row" v-if="dataTask.modalDistServ.modalshow">
                <form class="form">
                  <h5 class="form-section">
                    {{ $t("tasks.table.serviceDistance") }}
                  </h5>

                  <div class="col-md-12">
                    <div class="col-md-6 offset-md-3">
                      <div class="row" style="margin-bottom: 0.5em">
                        <div class="col-md-6">
                          <span>{{ $t("tasks.table.dtFrom") }}</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <input
                              type="date"
                              id="dFrom"
                              class="form-control border-primary"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <input
                              type="time"
                              id="tFrom"
                              class="form-control border-primary"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 offset-md-3">
                      <div class="row" style="margin-bottom: 0.5em">
                        <div class="col-md-6">
                          <span>{{ $t("tasks.table.dtTo") }}</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <input
                              type="date"
                              id="dTo"
                              class="form-control border-primary"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <input
                              type="time"
                              id="tTo"
                              class="form-control border-primary"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 offset-md-3">
                      <div class="form-group">
                        <label for="distance">{{
                          $t("tasks.table.distance") +
                          " (" +
                          $t("meas.km") +
                          ")"
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="distance"
                            name="distance"
                            class="form-control border-primary"
                            v-model="finishTaskData.distanceKM"
                          />
                          <div class="form-control-position">
                            <i class="icon-road"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div
                        class="form-actions right mb-0"
                        style="margin-top: 5px; padding: 5px 0"
                      >
                        <button
                          v-if="
                            !dataTask.moving.cancel &&
                            !dataTask.moving.finish &&
                            dataTask.btns.bring
                          "
                          type="button"
                          class="btn btn-warning"
                          style="margin-top: 5px"
                          @click="bringTask()"
                        >
                          <i class="icon-check2"></i>
                          {{ $t("tasks.buttons.bring") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- форма нової заявки -->
    <div ref="newTaskCont" id="newTaskCont"></div>
    <div class="row match-height" v-if="cr_task">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              <i class="icon-plus2"></i> {{ $t("tasks.titles.newTask") }}
            </h4>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="cr_task = false"
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body collapse in">
            <div class="card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("tasks.eqMethod.title") }}</h5>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button
                          type="button"
                          class="btn btn-primary btn-round"
                          @click="
                            barcode = false;
                            showModalQR();
                          "
                          data-html="true"
                          :title="$t('equipm.hint.scanQr')"
                        >
                          <i class="icon-qrcode"></i>
                        </button>
                      </div>
                      <input
                        class="form-control border-primary"
                        :class="{ 'border-danger': $v.newTask.serials.$error }"
                        type="text"
                        :placeholder="$t('equipm.table.serNumber')"
                        id="serial_enter"
                        v-model="newTask.serial"
                        v-on:keyup.enter="
                          addSerial({ serial: newTask.serial, address: null })
                        "
                        @change="
                          addSerial({ serial: newTask.serial, address: null })
                        "
                      />
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-warning btn-round"
                          @click="
                            addSerial({ serial: newTask.serial, address: null })
                          "
                        >
                          <i style="color: #ffffff" class="icon-plus2"></i>
                          {{ $t("tasks.buttons.addSerial") }}
                        </button>
                      </div>
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-primary btn-round"
                          @click="showModalEq()"
                          data-html="true"
                          :title="$t('tasks.eqMethod.equipm')"
                        >
                          <i class="icon-list" style="color: white"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <span
                    style="color: red"
                    class="d-flex mb-1"
                    v-if="$v.newTask.serials.$error"
                    >{{ $t("tasks.errors.entrSerial") }}</span
                  >

                  <div class="row mt-1 pl-1 pr-1">
                    <div class="form-group" v-if="newTask.serials.length > 0">
                      <button
                        type="button"
                        class="btn btn-danger btn-round"
                        @click="newTask.serials = []"
                        v-if="lenSerials > 1"
                      >
                        <i class="icon-bin"></i>
                        {{ $t("tasks.buttons.remove") }}
                      </button>
                      <span
                        v-for="(serial, index) in newTask.serials"
                        :key="index"
                        class="btn tag-default btn-warning"
                        style="margin: 0.2rem"
                      >
                        {{ serial.serial }}
                        <a
                          v-on:click="newTask.serials.splice(index, 1)"
                          data-html="true"
                          :title="$t('equipm.hint.delete')"
                          ><i class="icon-bin"></i
                        ></a>
                      </span>
                    </div>
                  </div>

                  <div class="mb-1">
                    <div class="input-group">
                      <div
                        class="form-control border-primary"
                        style="background-color: #eceeef"
                        :class="{ 'border-danger': $v.newTask.priority.$error }"
                        id="typeFltr"
                        @click="chPrior = !chPrior"
                      >
                        {{ choosPriorTitle }}
                      </div>
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-primary btn-round"
                          @click="chPrior = !chPrior"
                        >
                          <a class="dropdown-toggle" style="color: white"></a>
                        </button>
                      </div>
                      <div
                        class="dropdown-menu"
                        v-if="chPrior"
                        @mouseleave="chPrior = false"
                      >
                        <button
                          v-for="(item, index) in $store.state.priority"
                          :key="index"
                          class="dropdown-item"
                          :class="
                            'btn-' +
                            $t('priority.statuses.' + item.id + '.class')
                          "
                          type="button"
                          @click="
                            newTask.priority = item.id;
                            chPrior = !chPrior;
                          "
                        >
                          {{ $t("priority.statuses." + item.id + ".word") }}
                        </button>
                      </div>
                    </div>
                    <span v-if="$v.newTask.priority.$error" style="color: red">
                      <span
                        class="d-flex"
                        v-if="!$v.newTask.priority.required"
                        >{{ $t("errors.required") }}</span
                      >
                    </span>
                  </div>

                  <div class="mb-1">
                    <div class="input-group">
                      <div
                        class="form-control border-primary"
                        style="background-color: #eceeef"
                        :class="{ 'border-danger': $v.newTask.typeT.$error }"
                        id="typeFltr"
                        @click="chType = !chType"
                      >
                        {{ choosTypeTitle }}
                      </div>
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-primary btn-round"
                          @click="chType = !chType"
                        >
                          <a class="dropdown-toggle" style="color: white"></a>
                        </button>
                      </div>
                      <div
                        class="dropdown-menu"
                        v-if="chType"
                        @mouseleave="chType = false"
                      >
                        <button
                          v-for="(task, index) in $store.state.typesTask"
                          :key="index"
                          class="dropdown-item"
                          type="button"
                          @click="
                            newTask.typeT = task;
                            chType = !chType;
                          "
                        >
                          {{ $t(task.text) }}
                        </button>
                      </div>
                    </div>
                    <span v-if="$v.newTask.typeT.$error" style="color: red">
                      <span class="d-flex" v-if="!$v.newTask.typeT.required">{{
                        $t("errors.required")
                      }}</span>
                    </span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group position-relative has-icon-left">
                    <textarea
                      id="comment"
                      rows="3"
                      class="form-control border-primary"
                      name="comment"
                      :class="{ 'border-danger': $v.newTask.jobs.$error }"
                      :placeholder="$t('tasks.table.jobs')"
                      v-model.trim="$v.newTask.jobs.$model"
                    ></textarea>
                    <div class="form-control-position">
                      <i class="icon-stack"></i>
                    </div>
                    <span v-if="$v.newTask.jobs.$error" style="color: red">
                      <span class="d-flex" v-if="!$v.newTask.jobs.required">{{
                        $t("tasks.errors.jobs")
                      }}</span>
                      <span class="d-flex" v-if="!$v.newTask.jobs.minLength"
                        >{{ $t("errors.minLength") }}
                        {{ $v.newTask.jobs.$params.minLength.min }}</span
                      >
                    </span>
                  </div>

                  <div class="">
                    <div class="form-group">
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="address"
                          :placeholder="$t('equipm.table.location')"
                          name="address"
                          class="form-control border-primary"
                          v-model.trim="$v.newTask.address.$model"
                          :class="{
                            'border-danger': $v.newTask.address.$error,
                          }"
                        />
                        <div class="form-control-position">
                          <i class="icon-location-arrow"></i>
                        </div>
                      </div>
                      <span v-if="$v.newTask.address.$error" style="color: red">
                        <span
                          class="d-flex"
                          v-if="!$v.newTask.address.required"
                          >{{ $t("tasks.errors.address") }}</span
                        >
                        <span
                          class="d-flex"
                          v-if="!$v.newTask.address.minLength"
                          >{{ $t("errors.minLength") }}
                          {{ $v.newTask.address.$params.minLength.min }}</span
                        >
                      </span>
                    </div>
                  </div>

                  <!-- <div class="form-group">
                                        <textarea id="comment" rows="3" class="form-control border-primary" name="comment" :placeholder="$t('tasks.table.comment')" v-model="newTask.comment"></textarea>
                                    </div> -->
                </div>
              </div>

              <div class="row" v-if="newTask.checks.length > 0">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("problem.table.probl_categ") }}</h5>
                  </div>
                </div>

                <div
                  class="col-md-3"
                  v-for="(gr, ind) in newTask.checks"
                  :key="ind"
                >
                  <div
                    v-for="(ch, index) in gr"
                    :key="index"
                    class="hand"
                    @click="ch.checked = !ch.checked"
                    style="margin: 10px 5px 10px 5px"
                  >
                    <i
                      :class="[
                        ch.checked
                          ? 'icon-checkbox-checked'
                          : 'icon-checkbox-unchecked',
                      ]"
                      style="vertical-align: middle"
                    ></i>
                    <i
                      style="vertical-align: middle; margin-left: 5px"
                      class="font-large-1"
                      :class="ch.class"
                    ></i>
                    <span
                      style="
                        vertical-align: middle;
                        font-size: 1.3em;
                        max-width: 80%;
                        margin-left: 5px;
                      "
                    >
                      {{ $t(ch.title) }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <!-- <div class="mobileTbl table-responsive mb-1">
                                        <table class="table table-hover mb-0" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                                    <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                                    <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td :data-title="$t('equipm.table.country')">
                                                        <input type="text" id="country" class="form-control" name="country" v-model="newTask.addressT.country" >
                                                    </td>
                                                    <td :data-title="$t('equipm.table.region')">
                                                        <input type="text" id="region" class="form-control" name="region" v-model="newTask.addressT.region" >
                                                    </td>
                                                    <td :data-title="$t('equipm.table.city')">
                                                        <input type="text" id="city" class="form-control" name="city" v-model="newTask.addressT.city" >
                                                    </td>
                                                    <td :data-title="$t('equipm.table.street')">
                                                        <input type="text" id="street" class="form-control" name="street" v-model="newTask.addressT.street" >
                                                    </td>
                                                    <td :data-title="$t('equipm.table.number')" style="width: 8%">
                                                        <input type="text" id="streetN" class="form-control" name="streetN" v-model="newTask.addressT.streetN">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.index')" style="width 10%">
                                                        <input type="text" id="index" class="form-control" name="index" v-model="newTask.addressT.index" @keypress="isNumber($event)">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->

                  <div class="">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-images2"></i>
                        {{ $t("tasks.table.images") }}
                      </h4>

                      <div class="form-group mb-0">
                        <input
                          type="file"
                          name="file"
                          id="file"
                          class="inputfile"
                          multiple="multiple"
                          accept="image/x-png,image/jpeg,audio/mpeg3, video/*"
                          @change="onUploadImg"
                          :value="inputFileValue"
                        />
                        <label id="file_loader" for="file">
                          <a class="btn btn-primary btn-min-width"
                            ><i class="icon-upload3"></i>
                            {{ $t("tasks.buttons.file") }}</a
                          >
                        </label>
                        <button
                          type="button"
                          class="btn btn-warning"
                          @click="
                            cameraMode = true;
                            barcode = false;
                            showModalQR();
                          "
                          data-html="true"
                          :title="$t('equipm.hint.camera')"
                        >
                          <i style="color: #ffffff" class="icon-camera8"></i>
                          {{ $t("tasks.buttons.photo") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="
                            newTask.images = [];
                            newTask.images2 = [];
                          "
                          v-if="newTask.images.length > 0"
                        >
                          <i class="icon-bin"></i>
                          {{ $t("tasks.buttons.remove") }}
                        </button>
                      </div>
                      <span
                        style="color: red"
                        class="d-flex mt-1"
                        v-if="$v.newTask.images.$error"
                        >{{ $t("errors.filesEmpty") }}</span
                      >

                      <div class="row mt-1">
                        <div
                          class="col-md-12"
                          style="display: flex; flex-wrap: wrap"
                        >
                          <div
                            class="col-xs-3"
                            style="
                              padding: 0;
                              display: flex;
                              flex-direction: column;
                              align-content: center;
                              justify-content: center;
                              margin-bottom: 1em;
                            "
                            v-for="(image, index) in newTask.images"
                            :key="index"
                          >
                            <div
                              class="card hand mb-0"
                              style="margin-left: 5px"
                            >
                              <div class="w-100 h-100">
                                <i
                                  class="icon-cross delete-image-icon"
                                  @click="
                                    newTask.images.splice(index, 1);
                                    newTask.images2.splice(index, 1);
                                  "
                                  data-html="true"
                                  :title="$t('tasks.hint.delImg')"
                                ></i>
                                <img
                                  :src="image.data"
                                  style="max-width: 100%; max-height: 100%"
                                  @click="expandDiv(newTask.images, index)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <form class="form">
                <div class="form-actions right">
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="createTask()"
                    v-if="!$store.state.listRole.service"
                  >
                    <i style="color: #ffffff" class="icon-plus2"></i>
                    {{ $t("tasks.buttons.create") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- таблиця -->
    <div class="row match-height">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="icon-clipboard2"></i> {{ $t("titles.tasks") }}
            </h3>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                v-if="
                  $store.getters.getClient ||
                  $store.getters.getAdmin ||
                  $store.getters.getDispatcher
                "
                @click="addTaskCont()"
                data-toggle="tooltip"
                data-html="true"
                :title="$t('tasks.buttons.create')"
              >
                <i style="color: #ffffff" class="icon-plus2"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block pt-0">
              <div class="row mb-1">
                <div class="col-md-3">
                  <div class="input-group col-form-label-lg pb-0">
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef"
                      id="typeFltr"
                      @click="priorFltrShow = !priorFltrShow"
                    >
                      {{ choosPriorTitle2 }}
                    </div>

                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="priorFltrShow = !priorFltrShow"
                        data-html="true"
                        :title="$t('tasks.hint.fltrPrior')"
                      >
                        <a
                          class="icon-filter dropdown-toggle"
                          style="color: white"
                        ></a>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu" v-if="priorFltrShow">
                    <button
                      class="dropdown-item"
                      type="button"
                      @click="
                        priorChoosen = null;
                        priorFltrShow = !priorFltrShow;
                      "
                    >
                      {{ $t("tasks.statuses.all.title") }}
                    </button>
                    <button
                      v-for="(item, index) in $store.state.priority"
                      :key="index"
                      class="dropdown-item"
                      type="button"
                      @click="
                        priorChoosen = item.id;
                        priorFltrShow = !priorFltrShow;
                      "
                    >
                      {{ $t("priority.statuses." + item.id + ".word") }}
                    </button>
                  </div>
                </div>

                <div class="col-md-9">
                  <div class="col-form-label-lg pb-0">
                    <fieldset class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control input"
                        placeholder=""
                        v-model="filterStr"
                        data-toggle="tooltip"
                        data-html="true"
                        :title="$t('tasks.hint.find')"
                      />
                      <div class="form-control-position">
                        <i class="icon-search4 font-medium-4"></i>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div class="row" v-if="statuses.data.length > 0">
                <div class="col-md-12">
                  <div
                    v-for="(st, index) in statuses.data"
                    :key="index"
                    class="tag hand"
                    :class="$t(st.title + '.class')"
                    @click="filtrClick(st, statuses)"
                    style="
                      margin-right: 0.5em;
                      margin-bottom: 0.5em;
                      min-width: 10em;
                      max-width: 10em;
                      text-align: start;
                    "
                    data-toggle="tooltip"
                    data-html="true"
                    :title="$t('tasks.hint.fltrStatus')"
                  >
                    <i
                      :class="[
                        st.check
                          ? 'icon-checkbox-checked'
                          : 'icon-checkbox-unchecked',
                      ]"
                    ></i>
                    {{ $t(st.title + ".title") }}
                  </div>
                </div>
              </div>

              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:class="{ active: !loadOT }"
                    id="base-tab2"
                    data-toggle="tab"
                    @click="loadOT = false"
                  >
                    <i class="icon-clock3"></i>
                    {{ $t("tasks.titles.actTasks") }}
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    v-bind:class="{ active: loadOT }"
                    id="base-tab1"
                    data-toggle="tab"
                    @click="loadOT = true"
                  >
                    <i class="icon-history"></i>
                    {{ $t("tasks.titles.oldTasks") }}
                  </a>
                </li>
              </ul>

              <div class="mobileTbl table-responsive">
                <table class="table table-hover mb-0" cellspacing="0">
                  <thead>
                    <tr>
                      <th class="text-truncate" style="vertical-align: middle">
                        {{ $t("tasks.table.docNumb") }}
                        <a @click="sortData('DocNumber')"
                          ><i class="icon-sort"></i
                        ></a>
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.date") }}
                        <a @click="sortData('dt')"><i class="icon-sort"></i></a>
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.status") }}
                        <a @click="sortData('Status')"
                          ><i class="icon-sort"></i
                        ></a>
                        <!--<a ref="statusFiltr" @mouseenter="statusFilter"><i class="icon-arrow-down2"></i></a>-->
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.execPers") }}
                        <a @click="sortData('executor')"
                          ><i class="icon-sort"></i
                        ></a>
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.address") }}
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.jobs") }}
                      </th>
                      <th style="vertical-align: middle" class="text-truncate">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(eq, index) in paginatedData"
                      :key="index"
                      @click="getTaskInfo(eq)"
                      class="hand"
                    >
                      <!--paginatedData listTasks-->
                      <td
                        class="text-truncate"
                        :data-title="$t('tasks.table.docNumb')"
                      >
                        <span>{{ eq.DocNumber }}</span>
                        <span
                          v-if="eq.online"
                          class="avatar avatar-online"
                          style="width: 10px"
                          ><i
                            style="right: 0px; bottom: 0.3em"
                            data-toggle="tooltip"
                            data-html="true"
                            :title="$t('tasks.table.onlineTask')"
                          ></i
                        ></span>
                        <div v-if="eq.Priority != null">
                          <span
                            class="tag"
                            :class="
                              'tag-' +
                              $t('priority.statuses.' + eq.Priority + '.class')
                            "
                          >
                            {{
                              $t("priority.statuses." + eq.Priority + ".word")
                            }}
                          </span>
                        </div>
                        <div v-if="eq.Type != null">
                          <span>{{ eq.Type }}</span>
                        </div>
                        <div v-if="eq.Client">
                          {{ eq.Client }}
                        </div>
                      </td>
                      <td :data-title="$t('tasks.table.date')">
                        <span>{{ eq.Date }}</span>
                      </td>
                      <td
                        class="text-truncate"
                        :data-title="$t('tasks.table.status')"
                      >
                        <span class="tag" :class="$t(eq.Status + '.class')">{{
                          $t(eq.Status + ".title")
                        }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.execPers')" class="">
                        <span>{{ eq.Executor }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.address')" class="">
                        <a
                          v-if="eq.Adress.length > 5"
                          @click.self="showModalMap($event, eq.Adress, eq.JobS)"
                          >{{ eq.Adress }} <i class="icon icon-location2"></i
                        ></a>
                        <span v-else>{{ eq.Adress }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.jobs')" class="">
                        <span>{{ eq.JobS }}</span>
                      </td>
                      <td class="text-truncate">
                        <div
                          class="row"
                          style="float: right; margin-right: 5px"
                        >
                          <div class="input-group">
                            <button
                              type="button"
                              class="btn btn-warning btn-round"
                              @click.stop="getTaskInfo(eq)"
                              data-toggle="tooltip"
                              data-html="true"
                              :title="$t('tasks.hint.detail')"
                            >
                              <i class="icon-info"></i>
                            </button>
                            <!-- <button
                              v-if="eq.btn_start"
                              type="button"
                              class="btn btn-success btn-round"
                              @click.stop="
                                startFinTask = true;
                                taskItem = eq;
                                barcode = false;
                                showModalQR();
                              "
                              data-toggle="tooltip"
                              data-html="true"
                              :title="$t('tasks.hint.start')"
                            >
                              <i class="icon-play4"></i>
                            </button>
                            <button
                              v-if="eq.btn_end"
                              type="button"
                              class="btn btn-danger btn-round"
                              @click.stop="
                                startFinishTime(1, eq, null).then(() => {})
                              "
                              data-toggle="tooltip"
                              data-html="true"
                              :title="$t('tasks.hint.stop')"
                            >
                              <i class="icon-stop3"></i>
                            </button> -->
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="" style="text-align: center">
                <ul class="pagination">
                  <li class="page-item" v-if="pageNumber > 0">
                    <a class="page-link" @click="pageNumber--"
                      ><i class="icon-arrow-left2"></i
                    ></a>
                  </li>

                  <li
                    class="page-item"
                    v-bind:class="{ active: pageNumber == page - 1 }"
                    v-for="(page, index) in pages"
                    :key="index"
                  >
                    <a
                      v-if="page != '...'"
                      class="page-link"
                      @click="pageNumber = page - 1"
                      >{{ page }}</a
                    >
                    <a v-else class="page-link" :id="index">{{ page }}</a>
                  </li>

                  <li class="page-item" v-if="pageNumber < pageCount - 1">
                    <a class="page-link" @click="pageNumber++"
                      ><i class="icon-arrow-right2"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";

export default {
  name: "Tasks",
  data() {
    return {
      errors: [],
      listTasks: [],
      loadOT: false,

      cr_task: false,
      showinfo: false,

      finishTaskData: {
        serialsCheck: false,
        distanceKM: null,
        equipment: [],
        images: [],
        images2: [],
      },
      modalArr: [],

      dataTask: {
        //buttons of actions with task
        btns: {
          preCancel: false,
          cancel: false,
          bring: false,
          preFinish: false,
          finish: false,
          cancelChange: false,
          pdf: false,
          replacement: false,
        },
        moving: {
          cancel: false,
          finish: false,
          comment: false,
        },
        //buttons of actions with task

        addComm: false,
        newComment: "",

        GUID: null,
        status: null, //value for show status
        statusTXT: null, //text value for variant
        statusBP: null,
        variant: null,

        WorkType: null, //type task
        typeName: null, //title name type of task
        docNumber: null,
        organization: null,
        execPers: null,
        contPers: null,
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          index: null,
        },
        comment: null,
        jobs: null,

        countLoad: 3,
        countPhoto: 0,
        taskPict: [],

        fileReport: { name: "", data: null },
        equipment: [],
        history: [],
        sumHistory: null,

        reasonComment: null,
        priority: null,

        tabs: {
          info: true,
          photo: false,
          files: false,
          history: false,

          equipm: true,
          change: false,
        },

        modalDistServ: {
          modalshow: false,
          dtfrom: null,
          dtto: null,
        },

        categories: [],
        changes: [],
        chMainSer: null,
        chChange: null,
        changesList: [],
        problemsList: [], //відображення в інфо проблем з коментами

        problemName: null,
        problemGuid: null,
      },

      executors: [], //виконавці
      selected_executors: [],

      //sorting filtering
      filterStr: "",
      sortKey: "dt",
      direction: "desc",
      boolDir: false,
      classSort: "icon-sort-amount-asc",
      showFiltr: false,
      filterStatusClass: {
        left: "-200px",
        top: "-200px",
      },

      newTask: {
        serial: null, //"ме-20123469393"
        serials: [],
        comment: null,
        typeT: null,
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        jobs: null,
        priority: null,
        images: [],
        images2: [],

        checkAddress: false,

        checks: [],
      },

      //coords
      position: {
        latitude: null,
        longitude: null,
        accuracy: null,
      },

      pageNumber: 0, //pagination

      statuses: {
        data: [],
        choosen: [],
      },

      filesLimit: 15,

      startFinTask: false, //для кнопки старт/фініш час виконання заявки
      taskItem: null, //для кнопки старт/фініш час виконання заявки

      chPrior: false,
      priorChoosen: null,
      priorFltrShow: false,

      chType: false,

      modalMap: {
        position: { lat: null, lng: null },
        title: "",
      },
      modalArr: [],

      listProbShow: false,
      listProbShow2: false,
      probChoosen: null,

      tempBar: null,
      barcode: false,
      cameraMode: false,
      inputFileValue: null,
    };
  },
  validations: {
    newTask: {
      jobs: { required, minLength: minLength(4) },
      address: { required, minLength: minLength(4) },
      typeT: { required },
      priority: { required },
      images: { required, minLength: minLength(1), $each: { required } },
      serials: { required, minLength: minLength(1), $each: { required } },
    },
  },
  props: {
    //pagination
    size: {
      type: Number,
      required: false,
      default: 10,
    },
    paggSize: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  methods: {
    onUploadImg(e) {
      this.inputFileValue = null;
      let filename = null,
        filetype = null;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          filename = null;
          filetype = null;
          const element = e.target.files[i];

          filename = element.name;
          filetype = element.type;

          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            if (filetype.indexOf("image") > -1) {
              this.croppImg(e.target.result).then((result) => {
                let tt = result.split(",");

                let err = false;
                if (this.dataTask.moving.finish) {
                  if (this.finishTaskData.images.length <= this.filesLimit) {
                    this.finishTaskData.images.push({
                      name:
                        this.dataTask.DocNumber +
                        "_" +
                        Math.floor(Math.random() * 4999) +
                        ".png",
                      data: tt[0] + "," + tt[1],
                    });
                    this.finishTaskData.images2.push({
                      name:
                        this.dataTask.DocNumber +
                        "_" +
                        Math.floor(Math.random() * 4999) +
                        ".png",
                      data: tt[1],
                    });
                  } else {
                    err = true;
                  }
                } else {
                  if (this.newTask.images.length <= this.filesLimit) {
                    this.newTask.images.push({
                      name:
                        "newTask_" + Math.floor(Math.random() * 4999) + ".png",
                      data: tt[0] + "," + tt[1],
                    });
                    this.newTask.images2.push({
                      name:
                        "newTask_" + Math.floor(Math.random() * 4999) + ".png",
                      data: tt[1],
                    });
                  } else {
                    err = true;
                  }
                }
                if (err) {
                  this.$notify({
                    group: "info",
                    title: "Warning",
                    text: "Ліміт файлів " + this.filesLimit,
                  });
                }
              });
            }
          };
        }
      }
    },
    getCamRes(dataCam) {
      this.cameraMode = false;
      if (this.isValid(dataCam)) {
        if (this.dataTask.moving.finish) {
          this.finishTaskData.images.push({
            name:
              this.dataTask.docNumber +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png",
            data: dataCam /*.split(',')[1]*/,
          });
          this.finishTaskData.images2.push({
            name:
              this.dataTask.docNumber +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png",
            data: dataCam.split(",")[1],
          });
        } else {
          let name = "newTask_" + Math.floor(Math.random() * 4999) + ".png";
          this.newTask.images.push({ name: name, data: dataCam });
          this.newTask.images2.push({
            name: name,
            data: dataCam.split(",")[1],
          });
        }
      }
    },
    getListTasks() {
      this.listTasks = [];
      let dataRequest = { guidClient: this.$store.state.guidClient };

      if (this.isValid(dataRequest.guidClient)) {
        let str_query = "/service/getlisttask";
        if (this.loadOT) {
          //load old tasks
          str_query = "/service/getlistOldTask";
        }

        this.makeQuery(str_query, {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            if (result != null) {
              //by default all choosen
              if (this.statuses.data[0].check == false) {
                this.filtrClick(this.statuses.data[0], this.statuses);
              }

              let addTask = true;
              for (let i = 0; i < result.length; i++) {
                addTask = true;
                if (result[i].Date != null) {
                  result[i].dt = Math.round(new Date(result[i].Date));
                  result[i].Date = this.dtFormat(result[i].Date);
                } else {
                  result[i].dt = null;
                }

                //default off btns in table
                result[i].btn_start = false;
                result[i].btn_end = false;

                if (result[i].Date != null) {
                  result[i].StatusTXT = result[i].Status;

                  if (this.loadOT) {
                    result[i].StatusBP = 5;
                  }

                  //set status translate
                  switch (result[i].StatusBP) {
                    case 1: {
                      //СогласованиеЗаявки / нова
                      result[i].Status = "tasks.statuses.new";
                      addTask = false;
                      if (
                        this.$store.getters.getClient ||
                        this.$store.getters.getDispatcher ||
                        this.$store.getters.getAdmin
                      ) {
                        addTask = true;
                      }
                      break;
                    }
                    case 2: {
                      // до виконання
                      result[i].Status = "tasks.statuses.agreed";
                      break;
                    }
                    case 3: {
                      //ВыполнениеЗаявки / в роботі
                      result[i].Status = "tasks.statuses.process";
                      if (
                        this.$store.getters.getServiceOrg ||
                        this.$store.state.listRole.service ||
                        this.$store.state.listRole.admin
                      ) {
                        if (result[i].RunTimeLog == 0) {
                          result[i].btn_start = true;
                        } else if (result[i].RunTimeLog == 1) {
                          result[i].btn_end = true;
                        }
                      }
                      break;
                    }
                    case 4: {
                      //ВнесениеЗатрат
                      result[i].Status = "tasks.statuses.finish";
                      break;
                    }
                    case 5: {
                      result[i].Status = "tasks.statuses.done";
                      break;
                    }
                    case 6: {
                      result[i].Status = "tasks.statuses.cancel";
                      break;
                    }
                    case 7: {
                      result[i].Status = "tasks.statuses.bring";
                      if (
                        this.$store.getters.getServiceOrg ||
                        this.$store.state.listRole.service ||
                        this.$store.state.listRole.admin
                      ) {
                        if (result[i].RunTimeLog == 0) {
                          result[i].btn_start = true;
                        }
                      }
                      break;
                    }
                  }

                  //статус роботи заявки
                  result[i].online = false;
                  if (
                    result[i].RunTimeLog == 1 &&
                    (this.$store.getters.getDispatcher ||
                      this.$store.getters.getAdmin)
                  ) {
                    result[i].online = true;
                  }

                  if (
                    result[i].Priority == undefined ||
                    result[i].Priority == null
                  ) {
                    result[i].Priority = null;
                  }

                  if (addTask) {
                    this.listTasks.push(result[i]);
                  }
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    addTaskCont() {
      this.showNotification(
        "custom-info",
        "Функціонал недоступний",
        "Сервіс Мodern Expo переходить на нову платформу. Будь ласка, зареєструйте своє звернення за <a class='bold' style='text-decoration: underline;' href='https://sp.modern-expo.com/public/form/ecbb669bb776adcf'> цим посиланням </a>",
        -1
      );

      // this.clearDataTask();
      // if (this.showinfo) {
      //   this.showinfo = false;
      // }
      // this.cr_task = true;

      // this.anchorTo("newTaskCont");

      // this.getGPS()
      //   .then((result) => {
      //     this.position.latitude = result.latitude;
      //     this.position.longitude = result.longitude;
      //     this.position.accuracy = result.accuracy;
      //   })
      //   .catch((err) => {
      //     this.showNotification("custom-error", "Geolocation", err.message);
      //   });
    },
    getTaskInfo(task) {
      /*if (!e) var e = window.event;
                e.cancelBubble = true;
                if (e.stopPropagation) e.stopPropagation();*/

      if (this.cr_task) {
        this.cr_task = false;
      }

      this.clearDataTask();
      this.getGPS().then((result) => {
        this.position.latitude = result.latitude;
        this.position.longitude = result.longitude;
        this.position.accuracy = result.accuracy;
        console.log(result);
      });

      let dataRequest = {
        guidTask: task.GUID,
        quantityStart: 0,
        quantityFinish: 0,
      };

      this.makeQuery("/service/getinfotask", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            if (result.DocNumber != undefined) {
              this.dataTask.GUID = task.GUID;

              this.dataTask.msp_id = result.msp_id ? result.msp_id : null;
              if (task.btn_start) {
                this.dataTask.btn_start = task.btn_start;
                this.dataTask.btn_end = task.btn_end;
              }

              this.dataTask.execPers = result.Assignee;
              this.dataTask.docNumber = result.DocNumber;

              for (let i = 0; i < this.$store.state.typesTask.length; i++) {
                if (result.WorkType == this.$store.state.typesTask[i].val) {
                  this.dataTask.WorkType = this.$store.state.typesTask[i].text; //тип заявки
                }
              }
              //this.dataTask.typeName = ;

              this.dataTask.address = result.Adress;
              /*if((result.AdressSructure != undefined) && (result.AdressSructure != null)){
                                this.dataTask.addressT.country = result.AdressSructure.Country;
                                this.dataTask.addressT.region = result.AdressSructure.Region;
                                this.dataTask.addressT.city = result.AdressSructure.Location;
                                this.dataTask.addressT.street = result.AdressSructure.Street;
                                this.dataTask.addressT.streetN = result.AdressSructure.StreetN;
                                this.dataTask.addressT.index = result.AdressSructure.PostalCode;
                            }*/

              this.dataTask.organization = result.Organization;
              this.dataTask.status = result.Status;
              this.dataTask.statusTXT = result.Status;
              if (task.StatusBP) {
                this.dataTask.statusBP = task.StatusBP;
              }

              //buttons of actions with task to show
              if (!this.loadOT) {
                this.showActionBtns();
              } else {
                if (this.dataTask.statusBP == 5) {
                  this.dataTask.btns.pdf = true;
                }
              }

              this.dataTask.jobs = result.WorkList;
              this.dataTask.comment = result.Comment;
              this.dataTask.contPers = result.ClientInfo;

              let el;
              for (let i = 0; i < result.ArrayGoods.length; i++) {
                el = result.ArrayGoods[i];

                let guarant = false;
                if (el.ActivationDate) {
                  guarant = this.getGuarrantee(el.ActivationDate);
                  el.ActivationDate = this.dtFormat(el.ActivationDate);
                } else {
                  guarant = el.Guarantee;
                }

                if (el.WorkList == undefined) {
                  el.WorkList = null;
                }

                this.dataTask.equipment.push({
                  name: el.Goods,
                  serial: el.SN.trim(),
                  guid: el.GuidSerial,
                  article: el.Articule,
                  dtManuf: this.dtFormat(el.ProductionDate),
                  guarantee: guarant,
                  city: el.City,
                  actDt: el.ActivationDate,
                  history: el.WorkList,
                });
              }

              if (result.Priority == undefined || result.Priority == null) {
                this.dataTask.priority = null;
              } else {
                this.dataTask.priority = result.Priority;
              }
              //МЕ-00004068

              /*if((result.ArrayProblemEquipment != undefined) && (result.ArrayProblemEquipment.length > 0)){
                                this.dataTask.problemsList = [];

                                for (let i = 0; i < result.ArrayProblemEquipment.length; i++) {
                                    for (let j = 0; j < this.$store.state.categories.length; j++){
                                        if(this.$store.state.categories[j].id == parseFloat(result.ArrayProblemEquipment[i].icon)){
                                            this.dataTask.problemsList.push({
                                                id: this.$store.state.categories[j].id,
                                                guid: result.ArrayProblemEquipment[i].guid,
                                                title: result.ArrayProblemEquipment[i].name,
                                                class: this.$store.state.categories[j].class,
                                                comment: result.ArrayProblemEquipment[i].comment,
                                                edit: false,
                                                editbl: false
                                            });
                                            break
                                        }   
                                    }
                                }
                            }*/

              if (result.Problem) {
                this.dataTask.problemName = result.Problem.name;
                this.dataTask.problemGuid = result.Problem.id;
              }

              //this.getListProblems();

              this.showinfo = true;

              this.anchorTo("taskInfoCont");
            } else {
              this.showinfo = false;
              this.showNotification("custom-info", "Task", "No information");
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    createTask() {
      this.$v.newTask.typeT.$touch();
      this.$v.newTask.priority.$touch();
      this.$v.newTask.jobs.$touch();
      this.$v.newTask.typeT.$touch();
      this.$v.newTask.address.$touch();
      this.$v.newTask.images.$touch();
      this.$v.newTask.serials.$touch();

      if (
        !this.$v.newTask.typeT.$error &&
        !this.$v.newTask.priority.$error &&
        !this.$v.newTask.jobs.$error &&
        !this.$v.newTask.typeT.$error &&
        !this.$v.newTask.address.$error &&
        !this.$v.newTask.images.$error &&
        !this.$v.newTask.serials.$error
      ) {
        this.$v.newTask.typeT.$reset();
        this.$v.newTask.priority.$reset();
        this.$v.newTask.jobs.$reset();
        this.$v.newTask.typeT.$reset();
        this.$v.newTask.address.$reset();
        this.$v.newTask.images.$reset();
        this.$v.newTask.serials.$reset();

        let checks = [];
        //прохід по dataProblem.checks
        if (this.newTask.checks.length > 0) {
          for (let i = 0; i < this.newTask.checks.length; i++) {
            for (let j = 0; j < this.newTask.checks[i].length; j++) {
              if (this.newTask.checks[i][j].checked) {
                checks.push(this.newTask.checks[i][j].guid);
              }
            }
          }
        }

        let images = [],
          images2 = [],
          links = [];
        if (this.newTask.images.length > 0) {
          let data;
          for (let i = 0; i < this.newTask.images.length; i++) {
            if (typeof this.newTask.images[i].data == "string") {
              if (
                this.newTask.images[i].data.indexOf("/preview") > -1 &&
                this.newTask.images[i].data.indexOf("http") > -1
              ) {
                data = this.newTask.images[i].data.split("/preview")[0];
                links.push({ data: data, name: this.newTask.images[i].name });
              } else {
                images.push({
                  data: this.newTask.images[i].data,
                  name: this.newTask.images[i].name,
                });
                images2.push({
                  data: this.newTask.images2[i].data,
                  name: this.newTask.images2[i].name,
                });
              }
            }
          }
        }

        let dataRequest = {
          login: this.$store.state.user,
          type: this.newTask.typeT.val,
          serial: this.newTask.serials,
          comment: this.newTask.comment,
          jobs: this.newTask.jobs,
          guidClient: this.$store.state.guidClient,
          linksImages: links,
          arrayImage: images,
          arrayImage2: images2,
          position: this.position,
          address: this.newTask.address,
          priority: this.newTask.priority,
          guidProblem: this.guid,
          categories: checks,
          /*address: {
                            country : this.newTask.addressT.country,
                            region: this.newTask.addressT.region,
                            city: this.newTask.addressT.city,
                            street: this.newTask.addressT.street,
                            streetN: this.newTask.addressT.streetN,
                            index: this.newTask.addressT.index
                        },*/
        };

        this.makeQuery("/service/createtask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.showNotification(
              "custom-success",
              result,
              this.$t("tasks.titles.created"),
              -1
            );

            this.getListTasks();

            if (this.showinfo) {
              this.showinfo = false;
            }
            this.cr_task = false;
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },

    getQRSerial(serial) {
      if (this.startFinTask && this.isValid(this.taskItem.GUID)) {
        //запит на серійники
        this.startFinTask = false;

        //this.prestartFin(serial);
        this.startFinishTime(0, this.taskItem, serial).then(() => {});
      } else if (this.dataTask.moving.finish == true) {
        //check serials before finish task
        this.SerialsCheck(serial);
      } else if (this.dataTask.tabs.change) {
        for (let i = 0; i < this.dataTask.changes.length; i++) {
          if (this.dataTask.changes[i].id == this.dataTask.chChange.id) {
            this.dataTask.changes[i].serial = JSON.parse(
              JSON.stringify(serial)
            );
            this.dataTask.chChange = null;
            break;
          }
        }
      } else {
        this.newTask.serial = serial;
        this.addSerial({ serial: serial, address: null });
      }
    },
    addSerial(payload) {
      let ps = payload;
      if (this.isValid(ps.serial)) {
        let ser = this.checkPattSer(ps.serial);
        if (ser) {
          ps.serial = ser;
        } else {
          this.newTask.serial = null;
          return;
        }

        let ind_find = null;
        for (let i = 0; i < this.lenSerials; i++) {
          if (ps.serial == this.newTask.serials[i].serial) {
            //serial
            ind_find = i;
            break;
          }
        }

        if (ind_find == null) {
          this.newTask.serials.push(ps);
        }
        this.newTask.serial = null;
      }
    },
    checkAddresses() {
      if (this.lenSerials > 1 && this.newTask.checkAddress == false) {
        let addr = this.newTask.serials[0].address.substring(0, 10);
        for (let i = 1; i < this.lenSerials; i++) {
          if (this.newTask.serials[i].address.indexOf(addr) < 0) {
            this.showNotification(
              "custom-info",
              this.$t("tasks.titles.newTask"),
              this.$t("tasks.errors.adressNTask")
            );
            this.newTask.address = this.newTask.serials[0].address;
            this.newTask.checkAddress = true;
            break;
          }
        }
        this.newTask.address = this.newTask.serials[0].address;
      } else if (this.lenSerials == 1) {
        this.newTask.address = this.newTask.serials[0].address;
      }
    },
    sortData(key) {
      if (this.sortKey == key) {
        this.boolDir = !this.boolDir;
      } else {
        this.boolDir = false;
      }
      if (this.boolDir) {
        this.direction = "asc";
        this.classSort = "icon-sort-amount-asc";
      } else {
        this.direction = "desc";
        this.classSort = "icon-sort-amount-desc";
      }

      this.sortKey = key;
    },
    statusFilter(ev) {
      this.showFiltr = true;
      let self = this;
      let width;

      let top = ev.pageY;
      let left = ev.pageX;
      setTimeout(function () {
        width = self.$refs.filterStatus.clientWidth;
        left = left - width / 2;
        self.filterStatusClass.top = top + 15 + "px";
        self.filterStatusClass.left = left + "px";
      }, 100);
    },
    filtrClick(item, arr) {
      let notall = false; //не всі нажаті
      arr.choosen = [];

      item.check = !item.check;
      let bool = item.check;

      let itemAll = arr.data[0];

      if (item == itemAll) {
        for (let i = 0; i < arr.data.length; i++) {
          if (arr.data[i] != item) {
            arr.data[i].check = false;
          }
        }
      } else {
        if (itemAll.check == true) {
          item.check = true;
          for (let i = 0; i < arr.data.length; i++) {
            if (arr.data[i] != item) {
              arr.data[i].check = false;
            }
          }
        } else {
          for (let i = 0; i < arr.data.length; i++) {
            if (arr.data[i].check == false && arr.data[i] != itemAll) {
              notall = true;
            }
          }
          if (notall) {
            itemAll.check = false;
          } else {
            itemAll.check = true;
            for (let i = 0; i < arr.data.length; i++) {
              if (arr.data[i] != itemAll) {
                arr.data[i].check = false;
              }
            }
          }
        }
      }

      //нажаті
      for (let i = 0; i < arr.data.length; i++) {
        if (arr.data[i].check == true) {
          arr.choosen.push(arr.data[i]);
        }
      }

      if (arr.choosen.length < 1) {
        arr.data[0].check = true;
        arr.choosen.push(arr.data[0]);
      }
    },
    preCancel() {
      setTimeout(function () {
        document.getElementById("reasonComment").focus();
      }, 1000);
      this.dataTask.btns.cancel = true;
    },
    cancelChanges() {
      if (this.dataTask.moving.finish) {
        this.dataTask.moving.finish = false;
      } else if (this.dataTask.moving.cancel) {
        this.dataTask.moving.cancel = false;
        //очистка всього по cancel
      }
    },
    changeroutetask(button) {
      //idEvent, docGUID, GUID user

      this.dataTask.variant = this.getVariantTask(button);

      let dataRequest = {
        variant: this.dataTask.variant,
        guidTask: this.dataTask.GUID,
        status: this.dataTask.statusBP,
        cancelReason: this.dataTask.reasonComment,
        guidClient: this.$store.state.guidClient,
        finishComments: this.finishTaskData.equipment,
        distance: this.finishTaskData.distanceKM,
        arrayImage: [],
        arrayImage2: [],
        executors: this.selected_executors,
        guidUser: this.$store.getters.getGuidUser,
        servDtb: null,
        servDte: null,
      };

      if (
        button == 2 &&
        this.dataTask.statusBP == 3 &&
        this.dataTask.moving.finish
      ) {
        dataRequest.arrayImage = this.finishTaskData.images;
        dataRequest.arrayImage2 = this.finishTaskData.images2;
      }
      /*if(button == 0){
                    if(this.isValid(this.dataTask.modalDistServ.dtfrom) && 
                        this.isValid(this.dataTask.modalDistServ.dtto)){

                            dataRequest.servDtb = this.dataTask.modalDistServ.dtfrom;
                            dataRequest.servDte = this.dataTask.modalDistServ.dtto;
                        }
                    
                }*/

      if (
        dataRequest.variant != null &&
        dataRequest.guidTask != null &&
        dataRequest.status != null
      ) {
        this.makeQuery("/service/changeroutetask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            if (button == 0) {
              this.showNotification(
                "custom-success",
                this.dataTask.docNumber,
                this.$t("tasks.titles.accept")
              );
            } else if (button == 1) {
              //this.showNotification('custom-success',this.dataTask.docNumber,'Скасовано');
            } else if (button == 2) {
              this.showNotification(
                "custom-success",
                "Заявку " + this.dataTask.docNumber,
                this.$t("tasks.statuses.done.title")
              );
              this.dataTask.moving.finish == false;
            }

            if (this.showinfo) {
              this.showinfo = false;
            }

            this.getListTasks();
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        console.log(
          "Lost of data in Task " +
            this.dataTask.docNumber +
            " : variant: " +
            dataRequest.variant +
            " / guidTask: " +
            dataRequest.guidTask +
            " / status: " +
            dataRequest.status +
            " / guidClient: " +
            dataRequest.guidClient
        );
        this.showNotification(
          "custom-info",
          this.dataTask.docNumber,
          "Не вистачає даних для руху заявки"
        );
      }
    },
    clearDataTask() {
      this.dataTask.addComm = false;
      this.dataTask.newComment = "";

      this.dataTask.moving.cancel = false;
      this.dataTask.moving.finish = false;
      this.dataTask.moving.comment = false;

      this.dataTask.btns.pdf = false;
      this.dataTask.btns.replacement = false;

      this.dataTask.GUID = null;
      this.dataTask.status = null; //string
      this.dataTask.statusBP = null; //number
      this.dataTask.statusTXT = null; //string need!
      this.dataTask.variant = null;

      this.dataTask.WorkType = null;
      this.dataTask.typeName = null;
      this.dataTask.docNumber = null; //номер документа
      this.dataTask.organization = null;
      this.dataTask.execPers = null;
      this.dataTask.contPers = null;

      this.dataTask.address = null;

      this.dataTask.addressT.country = null;
      this.dataTask.addressT.region = null;
      this.dataTask.addressT.city = null;
      this.dataTask.addressT.street = null;
      this.dataTask.addressT.streetN = null;
      this.dataTask.addressT.index = null;

      this.dataTask.comment = null;
      this.dataTask.jobs = null;
      this.dataTask.taskPict = [];
      this.dataTask.fileReport = { name: "", data: null };
      this.dataTask.equipment = [];
      this.dataTask.history = [];
      this.dataTask.sumHistory = null;

      this.dataTask.reasonComment = null;
      this.dataTask.priority = null;

      this.dataTask.tabs.info = true;
      this.dataTask.tabs.photo = false;
      this.dataTask.tabs.files = false;
      this.dataTask.tabs.history = false;

      this.dataTask.tabs.equipm = true;
      this.dataTask.tabs.change = false;

      this.dataTask.modalDistServ.modalshow = false;
      this.dataTask.modalDistServ.dtfrom = null;
      this.dataTask.modalDistServ.dtto = null;

      this.newTask.serial = null;
      this.newTask.serials = [];
      this.newTask.comment = null;
      this.newTask.typeT = null;
      this.newTask.address = null;
      this.newTask.jobs = null;
      this.newTask.priority = null;
      this.newTask.images = [];
      this.newTask.images2 = [];
      this.newTask.checks = [];

      this.newTask.checkAddress = false;

      this.$v.newTask.typeT.$reset();
      this.$v.newTask.priority.$reset();
      this.$v.newTask.jobs.$reset();
      this.$v.newTask.typeT.$reset();
      this.$v.newTask.address.$reset();
      this.$v.newTask.images.$reset();
      this.$v.newTask.serials.$reset();

      //this.executors = [];
      this.selected_executors = [];

      this.dataTask.tabs.equipm = true;
      this.dataTask.tabs.change = false;
      this.probChoosen = null;
      this.dataTask.categories = [];
      this.dataTask.changes = [];
      this.dataTask.chMainSer = null;
      this.dataTask.chChange = null;
      this.listProbShow = false;
      this.listProbShow2 = false;

      this.dataTask.changesList = [];
      this.dataTask.problemsList = [];

      this.dataTask.problemName = null;
      this.dataTask.problemGuid = null;
    },
    showActionBtns() {
      //by default hide buttons in info task window
      this.dataTask.btns.bring = false;
      this.dataTask.btns.cancel = false;
      this.dataTask.btns.finish = false;
      this.dataTask.btns.preFinish = false;
      this.dataTask.btns.preCancel = false;
      this.dataTask.btns.cancelChange = false;
      this.dataTask.moving.cancel = false;
      this.dataTask.moving.finish = false;
      this.dataTask.moving.comment = false;
      this.dataTask.btns.pdf = false;
      this.dataTask.btns.replacement = false;

      //this.isValid(this.dataTask.status) this.isValid(this.dataTask.statusBP)
      let client = this.$store.getters.getClient;
      let admin = this.$store.getters.getAdmin;
      let service = this.$store.state.listRole.service;
      let serviceOrg = this.$store.getters.getServiceOrg;
      let dispatcher = this.$store.getters.getDispatcher;

      switch (this.dataTask.statusBP) {
        case 1: {
          //СогласованиеЗаявки нова
          if (serviceOrg || service || dispatcher || admin) {
            this.dataTask.btns.preCancel = true; //0
          }
          break;
        }
        case 2: {
          //планирование доВиконання
          if (service) {
            this.dataTask.btns.bring = true;
          }
          if (dispatcher || service) {
            this.dataTask.btns.preCancel = true;
          }
          break;
        }
        case 3: {
          //ВыполнениеЗаявки
          if (service || serviceOrg || admin) {
            this.dataTask.btns.preFinish = true;
            this.dataTask.btns.replacement = true;
          }
          if (dispatcher) {
            this.dataTask.btns.preCancel = true;
          }
          break;
        }
        case 4: {
          //до завершення
          if (client) {
            this.dataTask.btns.preFinish = true;
            this.dataTask.btns.preCancel = true;
          }
          break;
        }
        case 5: {
          this.dataTask.btns.pdf = true;
          break;
        } // завершена
        case 7: {
          //accepted
          if (service || serviceOrg || admin) {
            this.dataTask.btns.preFinish = true;
          }
          break;
        }
      }
    },
    cancelTask() {
      this.dataTask.moving.cancel = true;
    },
    finishTask() {
      if (this.$store.state.listRole.service) {
        let errors = [];

        if (this.dataTask.moving.finish == false) {
          if (errors.length == 0) {
            if (this.dataTask.btn_end && this.dataTask.btn_end == true) {
              this.startFinishTime(1, eq, null).then(() => {
                this.dataTask.moving.finish = true;
                this.barcode = false;
                this.showModalQR();
              });
            } else {
              this.dataTask.moving.finish = true;
              this.barcode = false;
              this.showModalQR();
            }
          } else {
            for (let i = 0; i < errors.length; i++) {
              this.showNotification(
                "custom-info",
                "Finishing task " + this.dataTask.docNumber,
                errors[i]
              );
            }
          }
        } else if (this.dataTask.moving.finish == true) {
          //перевірити серійники

          if (this.finishTaskData.serialsCheck == false) {
            errors.push("not all equipment added to task.");
          }

          if (this.dataTask.btn_end && this.dataTask.btn_end == true) {
            errors.push(this.$t("tasks.errors.startedJob"));
          }

          if (this.finishTaskData.images.length < 1) {
            errors.push(this.$t("tasks.errors.photo"));
          }

          //перевірка заповнених коментарів до обладнання
          /*for (let i = 0; i < this.finishTaskData.equipment.length; i++) {
                            if( !this.isValid(this.finishTaskData.equipment[i].comment) ){
                                console.log(this.isValid(this.finishTaskData.equipment[i].comment) + ' / ' + this.finishTaskData.equipment[i].comment)
                                errors.push(this.$t('tasks.errors.commEq'));
                                break
                            }
                        }*/

          //перевірити коментарі до замін, чи заповнені
          /*if(this.dataTask.problemsList.length > 0){
                            for (let i = 0; i < this.dataTask.problemsList.length; i++) {
                                if( !this.isValid(this.dataTask.problemsList[i].comment) ){
                                    errors.push('not all comments added to equipment.');
                                    break
                                }
                            }
                        }*/
          //перевірити коментарі до замін, чи заповнені

          if (errors.length == 0) {
            //відправка
            this.changeroutetask(2);
          } else {
            for (let i = 0; i < errors.length; i++) {
              this.showNotification(
                "custom-info",
                "Finishing task " + this.dataTask.docNumber,
                errors[i]
              );
            }
          }
        }
      } else if (!this.$store.state.listRole.service) {
        if (this.dataTask.moving.finish == false) {
          this.dataTask.moving.finish = true;
        } else if (this.dataTask.moving.finish == true) {
          this.changeroutetask(2);
        }
      }
    },
    SerialsCheck(serial) {
      //перевірка серійника з тим що в dataTask
      let foundScanned = false,
        foundExisted = false;
      this.finishTaskData.serialsCheck = false;

      //найти чи його немає у списку сканованих
      for (let j = 0; j < this.finishTaskData.equipment.length; j++) {
        if (this.finishTaskData.equipment[j].serial.indexOf(serial) > -1) {
          foundScanned = true;
          this.showNotification(
            "custom-info",
            serial,
            "Serail was added earlier"
          );
          break;
        }
      }

      //знайти чи співпадають серійники з сканованим
      if (foundScanned == false) {
        for (let i = 0; i < this.dataTask.equipment.length; i++) {
          if (this.dataTask.equipment[i].serial.indexOf(serial) > -1) {
            foundExisted = true;
            break;
          }
        }
        if (!foundExisted) {
          this.showNotification("custom-error", serial, "Wrong serial number!");
        }
      }

      if (foundExisted && !foundScanned) {
        this.finishTaskData.equipment.push({ serial: serial, comment: "" });
      }

      //check scanned serials with count of equipment in Task
      if (
        this.finishTaskData.equipment.length == this.dataTask.equipment.length
      ) {
        //всі серійники додано
        this.finishTaskData.serialsCheck = true;
        this.showNotification(
          "custom-success",
          "Equipment of task " + this.dataTask.docNumber,
          "All equipment have been added to task."
        );
      } else {
        this.finishTaskData.serialsCheck = false;
        this.showNotification(
          "custom-warning",
          "Task " + this.dataTask.docNumber,
          "Not all equipment was added to task"
        );
      }
    },
    getVariantTask(button) {
      //change executor -1
      //bring 0
      //cancel 1
      //finish 2
      switch (this.dataTask.statusBP) {
        case 1: {
          //'statuses.new'//СогласованиеЗаявки
          if (button == 1) {
            return 0;
          } else if (button == -1) {
            return 1; //призначення виконавця, далі рух заявки
          }
          break;
        }
        case 2: {
          //'statuses.agreed'
          if (button == 0) {
            return 3;
          } else if (button == 1) {
            if (!this.$store.getters.getClient) {
              return 0;
            }
          } else if (button == -1) {
            //зміна виконавця при до виконання
            return "";
          }
          break;
        }
        case 3: {
          //ВыполнениеЗаявки 'statuses.process'
          if (button == 2) {
            return 3; //якщо запущена до викон
          } else if (button == 1) {
            return 0;
          }
          break;
        }
        case 4: {
          //ВнесениеЗатрат 'statuses.finish'
          if (button == 2) {
            return 1;
          } else if (button == 1) {
            return 0; //отмена
          }
          break;
        }
        case 7: {
          //'statuses.bring' accepted
          if (button == 1) {
            //cancel accepted task
            return 6;
          }
          break;
        }
      }

      return null;
    },
    prestartFin(serial) {
      //отримати список серійників з сервера і перевірити введений зі списком

      let dataRequest = { guidTask: this.taskItem.GUID };
      this.makeQuery("/service/checkequipment", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          let found = false;
          let arrSerial = []; //список серійників
          //тут його заповнити
          for (let j = 0; j < arrSerial.length; j++) {
            //найти чи його немає у списку сканованих
            if (arrSerial[j].indexOf(serial) > -1) {
              found = true;
              break;
            }
          }

          if (found) {
            //this.startFinishTime(0, this.taskItem);
          } else {
            this.showNotification(
              "custom-error",
              "Serial",
              "You scan equipment not from this task"
            );
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });

      //якщо входить в список то робити запит
    },
    startFinishTime(button, item, serial = null) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      return new Promise((resolve, reject) => {
        //button boolean 0-start 1-finish
        let dataRequest = {
          runTimeLog: button,
          guidTask: item.GUID,
          serial: serial,
          position: this.position,
        };

        this.makeQuery("/service/startworkwithtask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            if (button == 0) {
              if (result.length > 0) {
                //uppercase
                var str = "";
                for (let i = 0; i < result.length; i++) {
                  str = str + result[i].DocNumber + ",";
                }
                str = str.substring(0, str.length - 1);
                this.showNotification(
                  "custom-error",
                  this.$t("tasks.errors.closeprev"),
                  str
                );
              } else {
                item.btn_start = false;
                item.btn_end = true;
                this.showNotification(
                  "custom-success",
                  this.$t("tasks.titles.task") + " " + item.DocNumber,
                  this.$t("tasks.titles.started")
                );
              }
            } else if (button == 1) {
              item.btn_start = true;
              item.btn_end = false;
              this.showNotification(
                "custom-success",
                this.$t("tasks.titles.task") + " " + item.DocNumber,
                this.$t("tasks.titles.stopped")
              );
            }

            this.taskItem = null;

            return resolve();
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
    saveCommentTask() {
      //
      if (this.dataTask.newComment.length > 2) {
        let dataRequest = {
          guidTask: this.dataTask.GUID,
          comments: this.dataTask.newComment,
        };

        let task = JSON.parse(JSON.stringify(this.dataTask));

        this.makeQuery("/service/addcomentsfortask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.showNotification("custom-success", "Comment", "Comment saved");
            this.dataTask.addComm = false;
            this.dataTask.newComment = "";

            this.getTaskInfo(task);
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        this.showNotification("custom-info", "Comment", "Too short comment!");
      }
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    sendReport() {
      let dataRequest = {
        guidTask: this.dataTask.GUID,
      };
      this.makeQuery("/service/printprotokol", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (
            (result.data != undefined || result.data != null) &&
            result.name != this.dataTask.fileReport.name
          ) {
            this.dataTask.fileReport.name = result.name;
            this.dataTask.fileReport.data = this.base64String(
              result.name,
              result.data
            );
          }

          if (this.dataTask.fileReport.data != null) {
            fileDownload(
              this.dataTask.fileReport.data,
              this.dataTask.fileReport.name
            );
          } else {
            this.showNotification(
              "custom-info",
              "File empty",
              this.dataTask.fileReport.name + ", contact Modern ASU!",
              -1
            );
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    loadPictures() {
      if (this.dataTask.taskPict.length < 1) {
        let dataRequest = { guidTask: this.dataTask.GUID };
        this.makeQuery2("/service/getImageTask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let arr_img = [],
              mark_old = false;

            if (
              result &&
              result.data &&
              result.data.signed_urls &&
              Array.isArray(result.data.signed_urls)
            ) {
              arr_img = result.data.signed_urls;
            }
            if (
              result &&
              result.data &&
              result.data.data &&
              Array.isArray(result.data.data)
            ) {
              arr_img = result.data.data;
              mark_old = true;
            }
            if (arr_img.length) {
              for (let i = 0; i < arr_img.length; i++) {
                if (mark_old) {
                  this.dataTask.taskPict.push(arr_img[i] + "/preview");
                } else {
                  this.dataTask.taskPict.push(arr_img[i].url);
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    loadHistory() {
      let mins = null;
      if (this.dataTask.history.length < 1) {
        this.dataTask.history = [];
        let dataRequest = { guidTask: this.dataTask.GUID };
        this.makeQuery("/service/getHistoryWork", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.dataTask.history = [];
            this.dataTask.history = result;

            this.dataTask.sumHistory = 0;

            for (let i = 0; i < this.dataTask.history.length; i++) {
              this.dataTask.history[i].date = this.dtFormat(
                this.dataTask.history[i].date
              );

              mins = this.dataTask.history[i].spentTime;
              if (typeof mins == "string" && mins.indexOf(",") > -1) {
                mins = mins.replace(",", ".");
                mins = parseFloat(mins);
              }
              this.dataTask.history[i].spentTime = Math.ceil(mins);

              this.dataTask.sumHistory =
                this.dataTask.sumHistory + this.dataTask.history[i].spentTime;
              switch (this.dataTask.history[i].stage) {
                case 0:
                  this.dataTask.history[i].stage = "history.statuses.new";
                  break;
                case 1:
                  this.dataTask.history[i].stage = "history.statuses.agreed";
                  break;
                case 2:
                  this.dataTask.history[i].stage = "history.statuses.process";
                  break;
                case 3:
                  this.dataTask.history[i].stage = "history.statuses.finish";
                  break;
                case 4:
                  this.dataTask.history[i].stage = "history.statuses.done";
                  break;
                case 5:
                  this.dataTask.history[i].stage = "history.statuses.cancel";
                  break;
                case 7:
                  this.dataTask.history[i].stage = "tasks.statuses.bring";
                  break;
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    showModalExec() {
      this.$store.state.modalExecutor = true;
      if (this.executors.length < 1) {
        let dataRequest = {};
        this.makeQuery("/service/getListExecutant", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.executors = [];
            for (let i = 0; i < result.length; i++) {
              result[i].checked = false;
              this.executors.push(result[i]);
            }

            this.$store.state.modalExecutor = true;
            //setTimeout(()=> { $("#modalExecutor").modal('toggle'); }, 400);
            this.$nextTick(() => {
              $("#modalExecutor").modal("toggle");
            });
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        for (let i = 0; i < this.executors.length; i++) {
          this.executors[i].checked = false;
        }
        this.$store.state.modalExecutor = true;
        //setTimeout(()=> {$("#modalExecutor").modal('toggle');}, 400);
        this.$nextTick(() => {
          $("#modalExecutor").modal("toggle");
        });
      }
    },
    closeExec(arr) {
      if (arr.length > 0) {
        console.log(arr);
        this.selected_executors = arr;

        this.changeroutetask(-1);
      }
    },

    //---------------------------model eq list------------------------------------------------
    showModalEq() {
      this.$refs.modalEq.showFrom().then((result) => {
        $("#modalEq").modal("toggle");
      });
    },
    getChoosenEq(payload) {
      for (let i = 0; i < payload.result.length; i++) {
        this.addSerial(payload.result[i]);
      }
    },
    //---------------------------model eq list------------------------------------------------

    showModalEqinfo(serial) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      this.$modals.show("InfoEq");
      this.$refs.eqInfo.getEqInfo(serial);
    },
    closeModalMap: function () {
      this.modalMap.position = { lat: 0, lng: 0 };
      this.$modals.hide("map-modal");
    },
    showModalMap(event, address, title) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      if (address != null && address.length > 5) {
        this.getCoords(address).then((result) => {
          if (result.results.length > 0) {
            this.modalMap.position.lat =
              result.results[0].geometry.location.lat;
            this.modalMap.position.lng =
              result.results[0].geometry.location.lng;

            this.modalMap.title = title;
            this.$modals.show("map-modal");
          }
          /*this.modalMap.position.lat = item.coordinate.lat;
                        this.modalMap.position.lng = item.coordinate.lng;
                        this.modalMap.title = item.name + ' (' + item.serial + ')';
                        this.$modals.show("map-modal");*/
        });
      }
    },
    bringTask() {
      /*if(this.$store.getters.getService || this.$store.getters.getAdmin){
                    if(this.dataTask.modalDistServ.modalshow){

                        let dtb = Math.round(new Date(document.getElementById('dFrom').value + ' ' + document.getElementById('tFrom').value));
                        let dte = Math.round(new Date(document.getElementById('dTo').value + ' ' + document.getElementById('tTo').value));

                        if(isNaN(dtb)){ dtb = null;}
                        if(isNaN(dte)){ dte = null;}

                        if((dte > dtb) && (this.isValid(dtb)) && (this.isValid(dte)) && (this.isValid(this.finishTaskData.distanceKM) )){
                            this.dataTask.modalDistServ.dtfrom = this.intdt_to_str(dtb);
                            this.dataTask.modalDistServ.dtto = this.intdt_to_str(dte);

                            this.dataTask.modalDistServ.modalshow = false;
                            this.changeroutetask(0);
                        }                        
                    } else {
                        this.dataTask.modalDistServ.modalshow = true;
                        //this.anchorTo('taskInfoCont');
                        $('html, body').animate({scrollTop: 0}, 600);
                    }
                }*/
      this.changeroutetask(0);
    },
    intdt_to_str(int_dt) {
      var d = new Date(int_dt);
      var day = d.getDate();
      var month = d.getMonth() + 1; //January is 0!
      var year = d.getFullYear();
      var hours = d.getHours();
      var min = d.getMinutes();
      var sec = d.getSeconds();

      if (sec < 10) {
        sec = "0" + sec;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return (
        year + "." + month + "." + day + " " + hours + ":" + min + ":" + sec
      );
    },
    getListProblems() {
      if (
        this.dataTask.categories.length < 1 &&
        this.dataTask.equipment.length > 0
      ) {
        let dataRequest = {
          guid: this.dataTask.equipment[0].guid,
        };
        if (dataRequest.guid != null) {
          this.makeQuery("/service/getListProblemEquipment", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < this.$store.state.categories.length; j++) {
                  if (
                    parseFloat(result[i].icon) ==
                    this.$store.state.categories[j].id
                  ) {
                    this.dataTask.categories.push({
                      id: this.$store.state.categories[j].id,
                      guid: result[i].guid,
                      title: result[i].name,
                      class: this.$store.state.categories[j].class,
                    });
                  }
                }
              }
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      }
    },
    addChange() {
      if (this.probChoosen != null) {
        let serial = null;
        /*for (let i = 0; i < this.dataTask.changes.length; i++) {
                        if(this.probChoosen.id == this.dataTask.changes[i].id){
                            this.probChoosen = null;
                            return
                        }
                    }*/
        if (this.dataTask.equipment.length == 1) {
          serial = this.dataTask.equipment[0].serial;
        }

        this.dataTask.changes.push({
          title: JSON.parse(JSON.stringify(this.probChoosen.title)),
          guid: JSON.parse(JSON.stringify(this.probChoosen.guid)),
          class: JSON.parse(JSON.stringify(this.probChoosen.class)),
          serialFrom: null,
          serialTo: null,
          id: JSON.parse(JSON.stringify(this.probChoosen.id)),
          serial: serial,
        });

        this.probChoosen = null;
      }
    },
    saveChange(item) {
      console.log(item);
      if (this.dataTask.changes.length > 0) {
        let smth_wrong = false;

        for (let i = 0; i < this.dataTask.changes.length; i++) {
          /*if( !this.isValid(this.dataTask.changes[i].serialFrom) ){
                            smth_wrong = true;
                            this.showNotification('custom-error',this.$t('errors.title'),this.$t('problem.errors.serFrom') );
                            break
                        }*/
          if (!this.isValid(this.dataTask.changes[i].serialTo)) {
            smth_wrong = true;
            this.showNotification(
              "custom-error",
              this.$t("errors.title"),
              this.$t("problem.errors.serTo")
            );
            break;
          }
          if (!this.isValid(this.dataTask.changes[i].serial)) {
            smth_wrong = true;
            this.showNotification(
              "custom-error",
              this.$t("errors.title"),
              this.$t("tasks.errors.entrSerial")
            );
            break;
          }
        }

        if (!smth_wrong) {
          let dataRequest = {
            arraySerial: [],
            position: this.position,
            guidTask: this.dataTask.GUID,
          };
          let eqGuid = null;
          for (let i = 0; i < this.dataTask.changes.length; i++) {
            eqGuid = null;
            for (let j = 0; j < this.dataTask.equipment.length; j++) {
              if (
                this.dataTask.equipment[j].serial ==
                this.dataTask.changes[i].serial
              ) {
                eqGuid = this.dataTask.equipment[j].guid;
                break;
              }
            }

            dataRequest.arraySerial.push({
              guidProblem: this.dataTask.changes[i].guid,
              serial: this.dataTask.changes[i].serial,
              guidEq: eqGuid,
              serialFrom: this.dataTask.changes[i].serialFrom,
              serialTo: this.dataTask.changes[i].serialTo,
            });
          }

          this.makeQuery("/service/changeEquipment", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              console.log(result);

              for (let i = 0; i < this.dataTask.changes.length; i++) {
                this.dataTask.changesList.push({
                  guidEquipment: null,
                  guidSerial: null,
                  nameEq: null,
                  from: this.dataTask.changes[i].serialFrom,
                  to: this.dataTask.changes[i].serialTo,
                  title: this.dataTask.changes[i].title,
                  class: this.dataTask.changes[i].class,
                  id: this.dataTask.changes[i].id,
                });
              }

              this.dataTask.changes = [];
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      }
    },
    getChangeList() {
      if (this.dataTask.changesList.length < 1) {
        let dataRequest = {
          guid: this.dataTask.GUID,
        };
        this.makeQuery("/service/getListChangeEquipment", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            /*guidEquipment: "e327f80b-3d45-11ec-80ed-248a07729990"
                        guidSerial: "628aa7ae-3745-11ec-80ed-248a07729990"
                        icon: "8"
                        nameNew: ""
                        nameOld: ""
                        nameSerial*/
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.$store.state.categories.length; j++) {
                if (
                  parseFloat(result[i].icon) ==
                  this.$store.state.categories[j].id
                ) {
                  this.dataTask.changesList.push({
                    guidEquipment: result[i].guidEquipment,
                    guidSerial: result[i].guidSerial,
                    nameEq: result[i].nameSerial,
                    from: result[i].nameOld,
                    to: result[i].nameNew,
                    title: this.$store.state.categories[j].title,
                    class: this.$store.state.categories[j].class,
                    id: this.$store.state.categories[j].id,
                  });
                  break;
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    getListCategories(guidEq) {
      let categories = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guid: guidEq,
        };
        this.makeQuery("/service/getListProblemEquipment", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.$store.state.categories.length; j++) {
                if (
                  parseFloat(result[i].icon) ==
                  this.$store.state.categories[j].id
                ) {
                  categories.push({
                    id: this.$store.state.categories[j].id,
                    guid: result[i].guid,
                    title: this.$store.state.categories[j].title,
                    class: this.$store.state.categories[j].class,
                    checked: false,
                  });
                  break;
                }
              }
            }
            return resolve(categories);
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
    onDecodeBar(data) {
      this.barcode = false;
      for (let i = 0; i < this.dataTask.changes.length; i++) {
        if (i == this.tempBar.index) {
          let item = this.dataTask.changes[i];
          item[this.tempBar.name] = JSON.parse(JSON.stringify(data));
          break;
        }
      }
    },
    commProblEq(item) {
      //this.dataTask.problemsList.id guid title class comment edit
      let dataRequest = {
        guidTask: guidTask,
        guidProbl: item.guid,
        comment: item.comment,
      };
      this.makeQuery("/service/saveCommProbl", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    showModalAppealinfo(guid) {
      this.$modals.show("InfoAppeal");
      this.$refs.appealInfo.getInfoProblem(guid);
    },
    clickMSPTask() {
      window.open(
        "https://sp.modern-expo.com/crm/task/" + this.dataTask.msp_id
      );
    },
  },
  computed: {
    listFiltered: function () {
      let find = this.filterStr.toLowerCase();
      let found1 = false;
      let found2 = false;
      let found3 = false;
      let keys = [];
      if (this.listTasks.length > 0) {
        keys = Object.keys(this.listTasks[0]);
      }

      this.pageNumber = 0;

      return this.listTasks.filter((item) => {
        found1 = false;
        found2 = false;
        found3 = false;

        for (let i = 0; i < keys.length; i++) {
          if (
            find == "" ||
            (item[keys[i]] != null &&
              typeof item[keys[i]] == "string" &&
              keys[i] != "GUID" &&
              item[keys[i]].toLowerCase().indexOf(find) > -1)
          ) {
            found1 = true;
            break;
          }
        }

        for (let i = 0; i < this.statuses.choosen.length; i++) {
          if (
            this.statuses.choosen[i].value == "" ||
            (item.Status != null &&
              item.Status.toLowerCase().indexOf(
                this.statuses.choosen[i].value.toLowerCase()
              ) > -1)
          ) {
            found2 = true;
            break;
          }
        }

        if (this.priorChoosen == null || this.priorChoosen == item.Priority) {
          found3 = true;
        }
        if (found1 && found2 && found3) {
          return item;
        }
      });
    },
    pageCount() {
      let l = this.listFiltered.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    pages: function () {
      let arr = [];
      let max_pages = this.pageCount;
      for (let i = 0; i < max_pages; i++) {
        arr[i] = i + 1;
      }
      let divider = Math.trunc(this.paggSize / 2);
      let start = this.pageNumber - divider;
      let end = this.pageNumber + divider + 1;
      if (start < 0) {
        start = 0;
      }
      let final_arr = arr.slice(start, end);
      if (start + 1 > arr[0]) {
        final_arr.unshift("...");
        final_arr.unshift(1);
      }
      if (end < arr[arr.length - 1]) {
        final_arr.push("...");
      }
      //add last page
      if (this.pageNumber + 1 + divider < max_pages) {
        final_arr.push(max_pages);
      }
      return final_arr;
    },
    paginatedData() {
      if (this.sortedData.length > 0) {
        //listFiltered
        const start = this.pageNumber * this.size,
          end = start + this.size;
        return this.sortedData.slice(start, end); //listFiltered
      }
    },
    sortedData: function () {
      return _.orderBy(this.listFiltered, this.sortKey, this.direction);
    },
    titleComment: function () {
      if (this.dataTask.moving.cancel) {
        return this.$t("tasks.table.commCancel");
      } else if (this.dataTask.moving.finish) {
        return this.$t("tasks.table.commFinish");
      }
    },
    typeTask: function () {
      return this.$t("titles.tasktype." + this.dataTask.WorkType);
    },
    choosPriorTitle: function () {
      if (this.newTask.priority == null) {
        return this.$t("priority.titles.empty");
      } else {
        return this.$t("priority.statuses." + this.newTask.priority + ".word");
      }
    },
    choosTypeTitle: function () {
      if (this.newTask.typeT == null) {
        return this.$t("tasks.table.deffType");
      } else {
        return this.$t(this.newTask.typeT.text);
      }
    },
    //priorChoosen
    choosPriorTitle2: function () {
      if (this.priorChoosen == null) {
        return this.$t("priority.titles.empty");
      } else {
        return this.$t("priority.statuses." + this.priorChoosen + ".word");
      }
    },
    choosProbl: function () {
      if (this.probChoosen == null) {
        return this.$t("problem.titles.chProbl");
      } else {
        return this.$t(this.probChoosen.title);
      }
    },
    lenSerials() {
      return this.newTask.serials.length;
    },
  },
  components: {},
  created() {
    this.checkAuthorized()
      .then((result) => {
        this.getListTasks();

        if (this.$route.params.guidTask != null) {
          this.getTaskInfo({ GUID: this.$route.params.guidTask });
        }
      })
      .catch((err) => {
        this.showNotification(
          "custom-error",
          this.$t("errors.title"),
          this.$t("errors.500")
        );
      });
  },
  mounted() {
    let el;
    this.statuses.data = [];
    for (let i = 0; i < this.$store.state.taskStatus.length; i++) {
      el = this.$store.state.taskStatus[i];
      this.statuses.data.push({
        title: el.name,
        value: el.value,
        id: el.id,
        check: false,
      });
    }

    console.log(this.$store.state.listRole);

    $('[data-toggle="tooltip"]').tooltip({
      trigger: "hover",
      placement: "top",
      animate: true,
      delay: 500,
      //container: 'body'
    });
  },
  watch: {
    "dataTask.moving.finish": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.finishTaskData.equipment = [];
        this.finishTaskData.distanceKM = null;
        this.finishTaskData.serialsCheck = false;
        this.finishTaskData.images = [];
        this.finishTaskData.images2 = [];

        this.dataTask.moving.comment = true;

        this.dataTask.btns.preCancel = false;
        this.dataTask.btns.cancel = false;
        this.dataTask.btns.bring = false;
        this.dataTask.btns.preFinish = false;
        this.dataTask.btns.finish = true;
        this.dataTask.btns.cancelChange = true;
      } else if (oldVal == true && newVal == false) {
        this.dataTask.btns.preCancel = true;
        this.dataTask.btns.cancel = false;
        this.dataTask.btns.bring = false;
        this.dataTask.btns.preFinish = true;
        this.dataTask.btns.finish = false;
        this.dataTask.btns.cancelChange = false;

        this.showActionBtns();

        this.finishTaskData.equipment = [];
        this.finishTaskData.serialsCheck = false;
        this.finishTaskData.distanceKM = null;
        this.finishTaskData.images = [];
        this.finishTaskData.images2 = [];
      }
    },
    "dataTask.moving.cancel": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.btns.preCancel = false;
        this.dataTask.btns.cancel = true;
        this.dataTask.btns.bring = false;
        this.dataTask.btns.preFinish = false;
        this.dataTask.btns.finish = false;
        this.dataTask.btns.cancelChange = false;

        this.dataTask.moving.comment = true;
      } else if (oldVal == true && newVal == false) {
        this.dataTask.btns.preCancel = true;
        this.dataTask.btns.cancel = false;
        this.dataTask.btns.bring = false;
        this.dataTask.btns.preFinish = false;
        this.dataTask.btns.finish = false;
        this.dataTask.btns.cancelChange = false;

        this.showActionBtns();
      }
    },
    "dataTask.moving.comment": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.reasonComment = null;
      }
    },
    showinfo: function (newVal, oldVal) {
      if (oldVal == true && newVal == false) {
        this.clearDataTask();
      }
    },
    cr_task: function (newVal, prevVal) {
      if (newVal == true && prevVal == false) {
        this.clearDataTask();
      }
    },
    "dataTask.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.files = false;
        this.dataTask.tabs.history = false;
      }
    },
    "dataTask.tabs.photo": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.files = false;
        this.dataTask.tabs.history = false;

        this.loadPictures();
      }
    },
    "dataTask.tabs.files": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.history = false;

        //this.loadInstructions();
      }
    },
    "dataTask.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.files = false;

        this.loadHistory();
      }
    },
    "dataTask.tabs.equipm": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.change = false;
      }
    },
    "dataTask.tabs.change": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.equipm = false;
        //this.getListProblems();
        this.getChangeList();

        this.getGPS()
          .then((result) => {
            this.position.latitude = result.latitude;
            this.position.longitude = result.longitude;
            this.position.accuracy = result.accuracy;
          })
          .catch((err) => {
            this.showNotification("custom-error", "Geolocation", err.message);
          });
      }
    },
    loadOT: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getListTasks();
      }
    },
    lenSerials(value) {
      if (value > 0 && this.cr_task) {
        if (this.newTask.serials[value - 1].address == null) {
          this.makeQuery("/service/productSerial", {
            dataRequest: {
              serial: this.newTask.serials[value - 1].serial,
              userGuid: this.$store.getters.getGuidUser,
            },
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              if (result.GUID != undefined) {
                if (result.Adress != undefined) {
                  this.newTask.serials[value - 1].address = result.Adress;
                  this.checkAddresses();
                }
              }
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        } else {
          this.checkAddresses();
        }
      } else if (value < 1) {
        this.newTask.address = null;
        this.newTask.checkAddress = false;
      }

      /*this.newTask.checks = [];
                    this.getListCategories(result.GUID)
                    .then(result => {
                        if(result.length > 0){
                            let checker = 0;
                            this.newTask.checks.push([]);

                            for (let j = 0; j < result.length; j++) {
                                if(this.newTask.checks[checker].length < 4){
                                    this.newTask.checks[checker].push(result[j]);
                                } else {
                                    checker = checker + 1;
                                    this.newTask.checks.push([]);
                                    this.newTask.checks[checker].push(result[j]);
                                }
                                
                            }
                        }
                    });*/
    },
  },
};
</script>

<style scoped>
.border-danger {
  border: 3px solid #da4453 !important;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#file_loader,
#file_loader2 {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}

.col-xs-4 {
  padding: 0;
}
</style> 


// WEBPACK FOOTER //
// src/pages/Tasks.vue